/*
 * @license
 * Broadcast Theme (c) Presidio Creative
 *
 * The contents of this file should not be modified.
 * add any minor changes to assets/custom.js
 *
 */
!(function (t) {
  "use strict";
  !(function () {
    const t = { NODE_ENV: "production" };
    try {
      if (process) return (process.env = Object.assign({}, process.env)), void Object.assign(process.env, t);
    } catch (t) {}
    globalThis.process = { env: t };
  })(),
    (window.theme = window.theme || {}),
    (window.theme.sizes = { mobile: 480, small: 750, large: 990, widescreen: 1400 }),
    (window.theme.focusable = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'),
    (window.theme.getWindowWidth = function () {
      return document.documentElement.clientWidth || document.body.clientWidth || window.innerWidth;
    }),
    (window.theme.getWindowHeight = function () {
      return document.documentElement.clientHeight || document.body.clientHeight || window.innerHeight;
    }),
    (window.theme.isMobile = function () {
      return window.theme.getWindowWidth() < window.theme.sizes.small;
    });
  window.theme.PUB_SUB_EVENTS = {
    cartUpdate: "cart-update",
    quantityUpdate: "quantity-update",
    optionValueSelectionChange: "option-value-selection-change",
    variantChange: "variant-change",
    cartError: "cart-error",
  };
  let e = {};
  (window.publish = function (t, s) {
    if (e[t]) {
      const i = e[t].map((t) => t(s));
      return Promise.all(i);
    }
    return Promise.resolve();
  }),
    (window.subscribe = function (t, s) {
      return (
        void 0 === e[t] && (e[t] = []),
        (e[t] = [...e[t], s]),
        function () {
          e[t] = e[t].filter((t) => t !== s);
        }
      );
    });
  (window.theme.formatMoney = function (t, e) {
    "string" == typeof t && (t = t.replace(".", ""));
    let s = "";
    const i = /\{\{\s*(\w+)\s*\}\}/,
      o = e || "${{amount}}";
    function n(t, e = 2, s = ",", i = ".") {
      if (isNaN(t) || null == t) return 0;
      const o = (t = (t / 100).toFixed(e)).split(".");
      return o[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, `$1${s}`) + (o[1] ? i + o[1] : "");
    }
    switch (o.match(i)[1]) {
      case "amount":
        s = n(t, 2);
        break;
      case "amount_no_decimals":
        s = n(t, 0);
        break;
      case "amount_with_comma_separator":
        s = n(t, 2, ".", ",");
        break;
      case "amount_no_decimals_with_comma_separator":
        s = n(t, 0, ".", ",");
        break;
      case "amount_with_apostrophe_separator":
        s = n(t, 2, "'", ".");
        break;
      case "amount_no_decimals_with_space_separator":
        s = n(t, 0, " ", "");
        break;
      case "amount_with_space_separator":
        s = n(t, 2, " ", ",");
        break;
      case "amount_with_period_and_space_separator":
        s = n(t, 2, " ", ".");
    }
    return o.replace(i, s);
  }),
    (window.theme.debounce = function (t, e) {
      let s;
      return function () {
        if (t) {
          const i = () => t.apply(this, arguments);
          clearTimeout(s), (s = setTimeout(i, e));
        }
      };
    });
  let s = n(),
    i = !0;
  function o() {
    const {
        windowHeight: t,
        headerHeight: e,
        logoHeight: o,
        footerHeight: r,
        collectionNavHeight: a,
      } = window.theme.readHeights(),
      l = n();
    (!i || l !== s || window.innerWidth > window.theme.sizes.mobile) &&
      (document.documentElement.style.setProperty("--full-height", `${t}px`),
      document.documentElement.style.setProperty("--three-quarters", t * (3 / 4) + "px"),
      document.documentElement.style.setProperty("--two-thirds", t * (2 / 3) + "px"),
      document.documentElement.style.setProperty("--one-half", t / 2 + "px"),
      document.documentElement.style.setProperty("--one-third", t / 3 + "px"),
      (s = l),
      (i = !1)),
      document.documentElement.style.setProperty("--collection-nav-height", `${a}px`),
      document.documentElement.style.setProperty("--header-height", `${e}px`),
      document.documentElement.style.setProperty("--footer-height", `${r}px`),
      document.documentElement.style.setProperty("--content-full", t - e - o / 2 + "px"),
      document.documentElement.style.setProperty("--content-min", t - e - r + "px");
  }
  function n() {
    return window.matchMedia("(orientation: portrait)").matches
      ? "portrait"
      : window.matchMedia("(orientation: landscape)").matches
      ? "landscape"
      : void 0;
  }
  function r(t) {
    const e = document.querySelector(t);
    return e ? e.offsetHeight : 0;
  }
  (window.theme.readHeights = function () {
    const t = {};
    return (
      (t.windowHeight = Math.min(window.screen.height, window.innerHeight)),
      (t.footerHeight = r('[data-section-type*="footer"]')),
      (t.headerHeight = r("[data-header-height]")),
      (t.stickyHeaderHeight = document.querySelector("[data-header-sticky]") ? t.headerHeight : 0),
      (t.collectionNavHeight = r("[data-collection-nav]")),
      (t.logoHeight = (function () {
        const t = r("[data-footer-logo]");
        return t > 0 ? t + 20 : 0;
      })()),
      t
    );
  }),
    o(),
    window.addEventListener("DOMContentLoaded", o),
    document.addEventListener("theme:resize", o),
    document.addEventListener("shopify:section:load", o),
    (window.theme.pauseAllMedia = function () {
      document.querySelectorAll('[data-host="youtube"]').forEach((t) => {
        t.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', "*");
      }),
        document.querySelectorAll('[data-host="vimeo"]').forEach((t) => {
          t.contentWindow.postMessage('{"method":"pause"}', "*");
        }),
        document.querySelectorAll("video").forEach((t) => t.pause()),
        document.querySelectorAll("product-model").forEach((t) => {
          t.modelViewerUI && t.modelViewerUI.pause();
        });
    }),
    (window.theme.scrollTo = (t) => {
      const e = document.querySelector("[data-header-sticky]")
        ? document.querySelector("[data-header-height]").offsetHeight
        : 0;
      window.scrollTo({ top: t + window.scrollY - e, left: 0, behavior: "smooth" });
    });
  const a = {},
    l = {
      forceFocus(t, e) {
        e = e || {};
        var s = t.tabIndex;
        (t.tabIndex = -1),
          (t.dataset.tabIndex = s),
          t.focus(),
          void 0 !== e.className && t.classList.add(e.className),
          t.addEventListener("blur", function i(o) {
            o.target.removeEventListener(o.type, i),
              (t.tabIndex = s),
              delete t.dataset.tabIndex,
              void 0 !== e.className && t.classList.remove(e.className);
          });
      },
      focusHash(t) {
        t = t || {};
        var e = window.location.hash,
          s = document.getElementById(e.slice(1));
        if (s && t.ignore && s.matches(t.ignore)) return !1;
        e && s && this.forceFocus(s, t);
      },
      bindInPageLinks(t) {
        return (
          (t = t || {}),
          Array.prototype.slice.call(document.querySelectorAll('a[href^="#"]')).filter((e) => {
            if ("#" === e.hash || "" === e.hash) return !1;
            if (t.ignore && e.matches(t.ignore)) return !1;
            if (((s = e.hash.substr(1)), null === document.getElementById(s))) return !1;
            var s,
              i = document.querySelector(e.hash);
            return (
              !!i &&
              (e.addEventListener("click", () => {
                this.forceFocus(i, t);
              }),
              !0)
            );
          })
        );
      },
      focusable(t) {
        return Array.prototype.slice
          .call(
            t.querySelectorAll(
              "[tabindex],[draggable],a[href],area,button:enabled,input:not([type=hidden]):enabled,object,select:enabled,textarea:enabled"
            )
          )
          .filter((t) => !(!(t.offsetWidth || t.offsetHeight || t.getClientRects().length) || !this.isVisible(t)));
      },
      trapFocus(t, e) {
        e = e || {};
        var s = this.focusable(t),
          i = e.elementToFocus || t,
          o = s[0],
          n = s[s.length - 1];
        this.removeTrapFocus(),
          (a.focusin = function (e) {
            t !== e.target && !t.contains(e.target) && o && o === e.target && o.focus(),
              (e.target !== t && e.target !== n && e.target !== o) || document.addEventListener("keydown", a.keydown);
          }),
          (a.focusout = function () {
            document.removeEventListener("keydown", a.keydown);
          }),
          (a.keydown = function (e) {
            "Tab" === e.code &&
              (e.target !== n || e.shiftKey || (e.preventDefault(), o.focus()),
              (e.target !== t && e.target !== o) || !e.shiftKey || (e.preventDefault(), n.focus()));
          }),
          document.addEventListener("focusout", a.focusout),
          document.addEventListener("focusin", a.focusin),
          this.forceFocus(i, e);
      },
      removeTrapFocus() {
        document.removeEventListener("focusin", a.focusin),
          document.removeEventListener("focusout", a.focusout),
          document.removeEventListener("keydown", a.keydown);
      },
      autoFocusLastElement() {
        window.a11y.lastElement &&
          document.body.classList.contains("is-focused") &&
          setTimeout(() => {
            var t;
            null === (t = window.a11y.lastElement) || void 0 === t || t.focus();
          });
      },
      accessibleLinks(t, e) {
        if ("string" != typeof t) throw new TypeError(t + " is not a String.");
        if (0 !== (t = document.querySelectorAll(t)).length) {
          (e = e || {}).messages = e.messages || {};
          var s,
            i,
            o,
            n = {
              newWindow: e.messages.newWindow || "Opens in a new window.",
              external: e.messages.external || "Opens external website.",
              newWindowExternal: e.messages.newWindowExternal || "Opens external website in a new window.",
            },
            r = e.prefix || "a11y",
            a = {
              newWindow: r + "-new-window-message",
              external: r + "-external-message",
              newWindowExternal: r + "-new-window-external-message",
            };
          t.forEach((t) => {
            var e = t.getAttribute("target"),
              s = t.getAttribute("rel"),
              i = (function (t) {
                return t.hostname !== window.location.hostname;
              })(t),
              o = "_blank" === e,
              n = null === s || -1 === s.indexOf("noopener");
            if (o && n) {
              var r = null === s ? "noopener" : s + " noopener";
              t.setAttribute("rel", r);
            }
            i && o
              ? t.setAttribute("aria-describedby", a.newWindowExternal)
              : i
              ? t.setAttribute("aria-describedby", a.external)
              : o && t.setAttribute("aria-describedby", a.newWindow);
          }),
            (s = n),
            (i = document.createElement("ul")),
            (o = Object.keys(s).reduce((t, e) => t + "<li id=" + a[e] + ">" + s[e] + "</li>", "")),
            i.setAttribute("hidden", !0),
            (i.innerHTML = o),
            document.body.appendChild(i);
        }
      },
      isVisible(t) {
        var e = window.getComputedStyle(t);
        return "none" !== e.display && "hidden" !== e.visibility;
      },
    };
  (window.theme = window.theme || {}),
    (window.theme.a11y = l),
    (window.theme.throttle = (t, e) => {
      let s, i;
      return function o(...n) {
        const r = Date.now();
        (i = clearTimeout(i)),
          !s || r - s >= e ? (t.apply(null, n), (s = r)) : (i = setTimeout(o.bind(null, ...n), e - (r - s)));
      };
    });
  let d = class extends HTMLElement {
    connectedCallback() {
      this.validateQtyRules(),
        (this.quantityUpdateUnsubscriber = subscribe(
          theme.PUB_SUB_EVENTS.quantityUpdate,
          this.validateQtyRules.bind(this)
        ));
    }
    disconnectedCallback() {
      this.quantityUpdateUnsubscriber && this.quantityUpdateUnsubscriber();
    }
    onInputChange(t) {
      this.validateQtyRules(), this.input && "updates[]" === this.input.name && this.updateCart();
    }
    onButtonClick(t) {
      var e, s;
      t.preventDefault();
      const i = this.input.value,
        o = "BUTTON" === t.target.nodeName ? t.target : t.target.closest("button"),
        n = o ? o.name : void 0,
        r = "decrease" === n || "minus" === n;
      var a, l;
      "increase" === n || "plus" === n
        ? parseInt(
            null === (a = this.input) || void 0 === a || null === (l = a.dataset) || void 0 === l ? void 0 : l.min
          ) > parseInt(this.input.step) && 0 == this.input.value
          ? (this.input.value = this.input.dataset.min)
          : this.input.stepUp()
        : r && this.input.stepDown();
      i !== this.input.value && this.input.dispatchEvent(this.changeEvent),
        (null === (e = this.input) || void 0 === e || null === (s = e.dataset) || void 0 === s ? void 0 : s.min) ===
          i &&
          r &&
          (this.input.value = parseInt(this.input.min));
    }
    validateQtyRules() {
      const t = parseInt(this.input.value);
      if (this.input.min) {
        const e =
          this.querySelector(".quantity__button[name='minus']") ||
          this.querySelector(".quantity__button[name='decrease']");
        e && e.classList.toggle("disabled", parseInt(t) <= parseInt(this.input.min));
      }
      if (this.input.max) {
        const e = parseInt(this.input.max),
          s =
            this.querySelector(".quantity__button[name='plus']") ||
            this.querySelector(".quantity__button[name='increase']");
        s && s.classList.toggle("disabled", t >= e);
      }
    }
    updateCart() {
      this.input &&
        "" !== this.input.value &&
        this.dispatchEvent(
          new CustomEvent("theme:cart:update", {
            bubbles: !0,
            detail: { id: this.input.dataset.id, quantity: this.input.value },
          })
        );
    }
    constructor() {
      var t, e, s;
      super(),
        (s = void 0),
        (e = "quantityUpdateUnsubscriber") in (t = this)
          ? Object.defineProperty(t, e, { value: s, enumerable: !0, configurable: !0, writable: !0 })
          : (t[e] = s),
        (this.input = this.querySelector("input")),
        (this.changeEvent = new Event("change", { bubbles: !0 })),
        this.input.addEventListener("change", this.onInputChange.bind(this)),
        this.querySelectorAll("button").forEach((t) => t.addEventListener("click", this.onButtonClick.bind(this)));
    }
  };
  customElements.define("quantity-input", d);
  function c() {
    if (document.querySelector("cart-items")) return;
    const t = document.createElement("cart-items");
    document.body.appendChild(t);
  }
  function h(t) {
    t.querySelectorAll(".form-field").forEach((t) => {
      const e = t.querySelector("label"),
        s = t.querySelector("input, textarea");
      e &&
        s &&
        (s.addEventListener("keyup", (t) => {
          "" !== t.target.value ? e.classList.add("label--float") : e.classList.remove("label--float");
        }),
        s.value && s.value.length && e.classList.add("label--float"));
    });
  }
  window.HTMLUpdateUtility = class t {
    static viewTransition(e, s, i = [], o = []) {
      null == i || i.forEach((t) => t(s));
      const n = document.createElement("div");
      t.setInnerHTML(n, s.outerHTML);
      const r = n.firstChild,
        a = Date.now();
      e.querySelectorAll("[id], [form]").forEach((t) => {
        t.id && (t.id = `${t.id}-${a}`), t.form && t.setAttribute("form", `${t.form.getAttribute("id")}-${a}`);
      }),
        e.parentNode.insertBefore(r, e),
        (e.style.display = "none"),
        null == o || o.forEach((t) => t(r)),
        setTimeout(() => e.remove(), 500);
    }
    static setInnerHTML(t, e) {
      (t.innerHTML = e),
        t.querySelectorAll("script").forEach((t) => {
          const e = document.createElement("script");
          Array.from(t.attributes).forEach((t) => {
            e.setAttribute(t.name, t.value);
          }),
            e.appendChild(document.createTextNode(t.innerHTML)),
            t.parentNode.replaceChild(e, t);
        });
    }
  };
  let u = window.theme.getWindowWidth(),
    m = window.theme.getWindowHeight();
  let p = window.scrollY,
    v = null,
    g = null,
    b = null,
    w = null,
    y = 0;
  function E(e) {
    setTimeout(() => {
      y && clearTimeout(y),
        t.disablePageScroll(e.detail, { allowTouchMove: (t) => "TEXTAREA" === t.tagName }),
        document.documentElement.setAttribute("data-scroll-locked", "");
    });
  }
  function f(t) {
    const e = t.detail;
    e ? (y = setTimeout(L, e)) : L();
  }
  function L() {
    t.clearQueueScrollLocks(), t.enablePageScroll(), document.documentElement.removeAttribute("data-scroll-locked");
  }
  const S = (t, e = "", s) => {
    const i = s || document.createElement("div");
    return i.classList.add(e), t.parentNode.insertBefore(i, t), i.appendChild(t);
  };
  function A(t) {
    t.querySelectorAll(".rte table").forEach((t) => {
      S(t, "rte__table-wrapper"), t.setAttribute("data-scroll-lock-scrollable", "");
    });
    t.querySelectorAll(
      '.rte iframe[src*="youtube.com/embed"], .rte iframe[src*="player.vimeo"], .rte iframe#admin_bar_iframe'
    ).forEach((t) => {
      S(t, "rte__video-wrapper");
    });
  }
  function k(t) {
    const e = t.querySelectorAll("[data-aria-toggle]");
    e.length &&
      e.forEach((t) => {
        t.addEventListener("click", function (t) {
          t.preventDefault();
          const e = t.currentTarget;
          e.setAttribute("aria-expanded", "false" == e.getAttribute("aria-expanded") ? "true" : "false");
          const s = e.getAttribute("aria-controls"),
            i = document.querySelector(`#${s}`),
            o = () => {
              i.classList.remove("expanding"), i.removeEventListener("transitionend", o);
            },
            n = () => {
              i.classList.add("expanding"), i.removeEventListener("transitionstart", n);
            };
          i.addEventListener("transitionstart", n),
            i.addEventListener("transitionend", o),
            i.classList.toggle("expanded");
        });
      });
  }
  const C = "is-loading",
    q = "img.is-loading";
  const T = "[data-aos]:not(.aos-animate)",
    M = "[data-aos-anchor]",
    x = "[data-aos]:not([data-aos-anchor]):not(.aos-animate)",
    H = "aos-animate",
    I = { attributes: !1, childList: !0, subtree: !0 };
  let P = [];
  const D = (t) => {
      for (const e of t)
        if ("childList" === e.type) {
          const t = e.target,
            s = t.querySelectorAll(T),
            i = t.querySelectorAll(M);
          s.length &&
            s.forEach((t) => {
              O.observe(t);
            }),
            i.length && B(i);
        }
    },
    O = new IntersectionObserver(
      (t, e) => {
        t.forEach((t) => {
          t.isIntersecting && (t.target.classList.add(H), e.unobserve(t.target));
        });
      },
      { root: null, rootMargin: "0px", threshold: [0, 0.1, 0.25, 0.5, 0.75, 1] }
    ),
    F = new IntersectionObserver(
      (t, e) => {
        t.forEach((t) => {
          if (t.intersectionRatio) {
            const s = t.target.querySelectorAll(T);
            s.length &&
              s.forEach((t) => {
                t.classList.add(H);
              }),
              e.unobserve(t.target);
            const i = P.indexOf("#" + t.target.id);
            -1 !== i && P.splice(i, 1);
          }
        });
      },
      { root: null, rootMargin: "0px", threshold: [0.1, 0.25, 0.5, 0.75, 1] }
    );
  function B(t) {
    t.length &&
      !Shopify.visualPreviewMode &&
      t.forEach((t) => {
        const e = t.dataset.aosAnchor;
        if (e && -1 === P.indexOf(e)) {
          const t = document.querySelector(e);
          t && (F.observe(t), P.push(e));
        }
      });
  }
  (window.requestIdleCallback =
    window.requestIdleCallback ||
    function (t) {
      var e = Date.now();
      return setTimeout(function () {
        t({
          didTimeout: !1,
          timeRemaining: function () {
            return Math.max(0, 50 - (Date.now() - e));
          },
        });
      }, 1);
    }),
    (window.cancelIdleCallback =
      window.cancelIdleCallback ||
      function (t) {
        clearTimeout(t);
      }),
    window.theme.settings.enableAnimations &&
      (!(function () {
        const t = document.querySelectorAll(x);
        t.length &&
          t.forEach((t) => {
            O.observe(t);
          });
      })(),
      (function () {
        const t = document.querySelectorAll(M);
        t.length && B(t);
      })(),
      new MutationObserver(D).observe(document.body, I),
      document.addEventListener("shopify:section:unload", (t) => {
        var e;
        const s = "#" + (null === (e = t.target.querySelector("[data-section-id]")) || void 0 === e ? void 0 : e.id),
          i = P.indexOf(s);
        -1 !== i && P.splice(i, 1);
      })),
    window.addEventListener(
      "resize",
      window.theme.debounce(function () {
        document.dispatchEvent(new CustomEvent("theme:resize", { bubbles: !0 })),
          u !== window.theme.getWindowWidth() &&
            (document.dispatchEvent(new CustomEvent("theme:resize:width", { bubbles: !0 })),
            (u = window.theme.getWindowWidth())),
          m !== window.theme.getWindowHeight() &&
            (document.dispatchEvent(new CustomEvent("theme:resize:height", { bubbles: !0 })),
            (m = window.theme.getWindowHeight()));
      }, 50)
    ),
    (function () {
      let t;
      window.addEventListener(
        "scroll",
        function () {
          t && window.cancelAnimationFrame(t),
            (t = window.requestAnimationFrame(function () {
              !(function () {
                const t = window.scrollY;
                t > p ? ((g = !0), (v = !1)) : t < p ? ((g = !1), (v = !0)) : ((v = null), (g = null)),
                  (p = t),
                  document.dispatchEvent(
                    new CustomEvent("theme:scroll", { detail: { up: v, down: g, position: t }, bubbles: !1 })
                  ),
                  v &&
                    !b &&
                    document.dispatchEvent(
                      new CustomEvent("theme:scroll:up", { detail: { position: t }, bubbles: !1 })
                    ),
                  g &&
                    !w &&
                    document.dispatchEvent(
                      new CustomEvent("theme:scroll:down", { detail: { position: t }, bubbles: !1 })
                    ),
                  (w = g),
                  (b = v);
              })();
            }));
        },
        { passive: !0 }
      ),
        window.addEventListener("theme:scroll:lock", E),
        window.addEventListener("theme:scroll:unlock", f);
    })(),
    "ontouchstart" in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0
      ? ((document.documentElement.className = document.documentElement.className.replace(
          "no-touch",
          "supports-touch"
        )),
        (window.theme.touch = !0))
      : (window.theme.touch = !1),
    document.addEventListener(
      "load",
      (t) => {
        "img" == t.target.tagName.toLowerCase() &&
          t.target.classList.contains(C) &&
          (t.target.classList.remove(C),
          t.target.parentNode.classList.remove(C),
          t.target.parentNode.parentNode.classList.contains(C) && t.target.parentNode.parentNode.classList.remove(C));
      },
      !0
    ),
    window.addEventListener("DOMContentLoaded", () => {
      k(document),
        h(document),
        A(document),
        document.querySelectorAll(q).forEach((t) => {
          t.complete &&
            (t.classList.remove(C),
            t.parentNode.classList.remove(C),
            t.parentNode.parentNode.classList.contains(C) && t.parentNode.parentNode.classList.remove(C));
        }),
        document.body.classList.add("is-loaded"),
        c(),
        requestIdleCallback(() => {
          Shopify.visualPreviewMode && document.documentElement.classList.add("preview-mode");
        });
    }),
    document.addEventListener("shopify:section:load", (t) => {
      const e = t.target;
      h(e), A(e), k(document);
    });
  const $ = "is-focused",
    _ = "[data-skip-content]",
    R = 'a[href="#"]';
  function W(t) {
    (this.status = t.status || null),
      (this.headers = t.headers || null),
      (this.json = t.json || null),
      (this.body = t.body || null);
  }
  (window.a11y = new (class {
    init() {
      (this.a11y = window.theme.a11y),
        (this.html = document.documentElement),
        (this.body = document.body),
        (this.inPageLink = document.querySelector(_)),
        (this.linkesWithOnlyHash = document.querySelectorAll(R)),
        this.a11y.focusHash(),
        this.a11y.bindInPageLinks(),
        this.clickEvents(),
        this.focusEvents();
    }
    clickEvents() {
      this.inPageLink &&
        this.inPageLink.addEventListener("click", (t) => {
          t.preventDefault();
        }),
        this.linkesWithOnlyHash &&
          this.linkesWithOnlyHash.forEach((t) => {
            t.addEventListener("click", (t) => {
              t.preventDefault();
            });
          });
    }
    focusEvents() {
      document.addEventListener("mousedown", () => {
        this.body.classList.remove($);
      }),
        document.addEventListener("keyup", (t) => {
          "Tab" === t.code && this.body.classList.add($);
        });
    }
    constructor() {
      this.init();
    }
  })()),
    (window.theme.waitForAnimationEnd = function (t) {
      return new Promise((e) => {
        null == t ||
          t.addEventListener("animationend", function s(i) {
            i.target == t && (t.removeEventListener("animationend", s), e());
          });
      });
    }),
    (window.theme.waitForAllAnimationsEnd = function (t) {
      return new Promise((e, s) => {
        const i = t.querySelectorAll("[data-aos]");
        let o = 0;
        function n(t) {
          o++, o === i.length && e(), t.target.removeEventListener("animationend", n);
        }
        i.forEach((t) => {
          t.addEventListener("animationend", n);
        }),
          o || s();
      });
    }),
    (W.prototype = Error.prototype);
  const N = "is-animated",
    U = "is-added",
    V = "is-disabled",
    z = "is-empty",
    j = "is-hidden",
    X = "is-hiding",
    K = "is-loading",
    Q = "is-open",
    Y = "is-removed",
    G = "is-success",
    J = "is-visible",
    Z = "is-expanded",
    tt = "is-updated",
    et = "variant--soldout",
    st = "variant--unavailable",
    it = {
      apiContent: "[data-api-content]",
      apiLineItems: "[data-api-line-items]",
      apiUpsellItems: "[data-api-upsell-items]",
      apiBundleItems: "[data-api-bundle-items]",
      apiCartPrice: "[data-api-cart-price]",
      animation: "[data-animation]",
      buttonSkipUpsellProduct: "[data-skip-upsell-product]",
      cartBarAdd: "[data-cart-bar-add-to-cart]",
      cartCloseError: "[data-cart-error-close]",
      cartDrawer: "cart-drawer",
      cartDrawerClose: "[data-cart-drawer-close]",
      cartEmpty: "[data-cart-empty]",
      cartErrors: "[data-cart-errors]",
      cartItemRemove: "[data-item-remove]",
      cartPage: "[data-cart-page]",
      cartForm: "[data-cart-form]",
      cartTermsCheckbox: "[data-cart-acceptance-checkbox]",
      cartCheckoutButtonWrapper: "[data-cart-checkout-buttons]",
      cartCheckoutButton: "[data-cart-checkout-button]",
      cartTotal: "[data-cart-total]",
      checkoutButtons: "[data-checkout-buttons]",
      errorMessage: "[data-error-message]",
      formCloseError: "[data-close-error]",
      formErrorsContainer: "[data-cart-errors-container]",
      formWrapper: "[data-form-wrapper]",
      freeShipping: "[data-free-shipping]",
      freeShippingGraph: "[data-progress-graph]",
      freeShippingProgress: "[data-progress-bar]",
      headerWrapper: "[data-header-wrapper]",
      item: "[data-item]",
      itemsHolder: "[data-items-holder]",
      leftToSpend: "[data-left-to-spend]",
      navDrawer: "[data-drawer]",
      outerSection: "[data-section-id]",
      priceHolder: "[data-cart-price-holder]",
      quickAddHolder: "[data-quick-add-holder]",
      quickAddModal: "[data-quick-add-modal]",
      qtyInput: 'input[name="updates[]"]',
      upsellProductsHolder: "[data-upsell-products]",
      bundleProductsHolder: "[data-bundle-products]",
      upsellWidget: "[data-upsell-widget]",
      bundleWidget: "[data-bundle-widget]",
      termsErrorMessage: "[data-terms-error-message]",
      collapsibleBody: "[data-collapsible-body]",
      discountInput: "[data-discount-input]",
      discountField: "[data-discount-field]",
      discountButton: "[data-apply-discount]",
      discountBody: "[data-discount-body]",
      discountCode: "[data-discount-code]",
      discountErrorMessage: "[data-discount-error-message]",
      removeDiscount: "[data-remove-discount]",
    },
    ot = "data-cart-total",
    nt = "disabled",
    rt = "data-free-shipping",
    at = "data-free-shipping-limit",
    lt = "data-item",
    dt = "data-item-index",
    ct = "data-item-title",
    ht = "open",
    ut = "data-quick-add-holder",
    mt = "data-scroll-locked",
    pt = "data-upsell-auto-open",
    vt = "data-max-inventory-reached",
    gt = "data-error-message-position";
  let bt = class extends HTMLElement {
    connectedCallback() {
      (this.cartPage = document.querySelector(it.cartPage)),
        (this.cartForm = document.querySelector(it.cartForm)),
        (this.cartDrawer = document.querySelector(it.cartDrawer)),
        (this.cartEmpty = document.querySelector(it.cartEmpty)),
        (this.cartTermsCheckbox = document.querySelector(it.cartTermsCheckbox)),
        (this.cartCheckoutButtonWrapper = document.querySelector(it.cartCheckoutButtonWrapper)),
        (this.cartCheckoutButton = document.querySelector(it.cartCheckoutButton)),
        (this.checkoutButtons = document.querySelector(it.checkoutButtons)),
        (this.itemsHolder = document.querySelector(it.itemsHolder)),
        (this.priceHolder = document.querySelector(it.priceHolder)),
        (this.items = document.querySelectorAll(it.item)),
        (this.cartTotal = document.querySelector(it.cartTotal)),
        (this.freeShipping = document.querySelectorAll(it.freeShipping)),
        (this.cartErrorHolder = document.querySelector(it.cartErrors)),
        (this.cartCloseErrorMessage = document.querySelector(it.cartCloseError)),
        (this.headerWrapper = document.querySelector(it.headerWrapper)),
        (this.navDrawer = document.querySelector(it.navDrawer)),
        (this.upsellProductsHolder = document.querySelector(it.upsellProductsHolder)),
        (this.bundleProductsHolder = document.querySelector(it.bundleProductsHolder)),
        (this.subtotal = window.theme.subtotal),
        (this.discountInput = document.querySelector(it.discountInput)),
        (this.discountField = document.querySelector(it.discountField)),
        (this.discountButton = document.querySelector(it.discountButton)),
        (this.hasDiscountBlock = !!document.querySelector(it.discountButton)),
        (this.discountErrorMessage = document.querySelector(it.discountErrorMessage)),
        (this.existingDiscountCodes = []),
        (this.discounts = document.querySelectorAll(it.discountBody)),
        (this.cart = this.cartDrawer || this.cartPage),
        this.hasDiscountBlock &&
          (this.discountButton.addEventListener("click", (t) => {
            t.preventDefault();
            const e = this.discountInput.value.trim();
            (this.discountInput.value = ""), e && this.applyDiscount(e);
          }),
          this.bindDiscountEventListeners()),
        (this.animateItems = this.animateItems.bind(this)),
        (this.addToCart = this.addToCart.bind(this)),
        (this.cartAddEvent = this.cartAddEvent.bind(this)),
        (this.updateProgress = this.updateProgress.bind(this)),
        (this.onCartDrawerClose = this.onCartDrawerClose.bind(this)),
        document.addEventListener("theme:cart:add", this.cartAddEvent),
        document.addEventListener("theme:announcement:init", this.updateProgress),
        "drawer" == theme.settings.cartType &&
          (document.addEventListener("theme:cart-drawer:open", this.animateItems),
          document.addEventListener("theme:cart-drawer:close", this.onCartDrawerClose)),
        (this.skipUpsellProductsArray = []),
        (this.skipBundleProductsArray = []),
        this.skipUpsellOrBundleProductEvent(),
        this.checkSkippedUpsellOrBundleProductsFromStorage(),
        this.toggleCartUpsellOrBundleWidgetVisibility(),
        (this.circumference = 28 * Math.PI),
        (this.freeShippingLimit = this.freeShipping.length
          ? 100 * Number(this.freeShipping[0].getAttribute(at)) * window.Shopify.currency.rate
          : 0),
        this.freeShippingMessageHandle(this.subtotal),
        this.updateProgress(),
        (this.build = this.build.bind(this)),
        (this.updateCart = this.updateCart.bind(this)),
        (this.productAddCallback = this.productAddCallback.bind(this)),
        (this.formSubmitHandler = window.theme.throttle(this.formSubmitHandler.bind(this), 50)),
        this.cartPage && this.animateItems(),
        this.cart &&
          ((this.hasItemsInCart = this.hasItemsInCart.bind(this)), (this.cartCount = this.getCartItemCount())),
        (this.toggleClassesOnContainers = this.toggleClassesOnContainers.bind(this)),
        (this.totalItems = this.items.length),
        (this.showCannotAddMoreInCart = !1),
        (this.cartUpdateFailed = !1),
        (this.discountError = !1),
        this.cartEvents(),
        this.cartRemoveEvents(),
        this.cartUpdateEvents(),
        document.addEventListener("theme:product:add", this.productAddCallback),
        document.addEventListener("theme:product:add-error", this.productAddCallback),
        document.addEventListener("theme:cart:refresh", this.getCart.bind(this));
    }
    disconnectedCallback() {
      document.removeEventListener("theme:cart:add", this.cartAddEvent),
        document.removeEventListener("theme:cart:refresh", this.cartAddEvent),
        document.removeEventListener("theme:announcement:init", this.updateProgress),
        document.removeEventListener("theme:product:add", this.productAddCallback),
        document.removeEventListener("theme:product:add-error", this.productAddCallback),
        document.documentElement.hasAttribute(mt) &&
          document.dispatchEvent(new CustomEvent("theme:scroll:unlock", { bubbles: !0 }));
    }
    onCartDrawerClose() {
      var t, e;
      (this.resetAnimatedItems(),
      (null === (t = this.cartDrawer) || void 0 === t ? void 0 : t.classList.contains(Q)) &&
        this.cart.classList.remove(tt),
      this.cartEmpty.classList.remove(tt),
      this.cartErrorHolder.classList.remove(Z),
      this.cart.querySelectorAll(it.animation).forEach((t) => {
        const e = () => {
          t.classList.remove(X), t.removeEventListener("animationend", e);
        };
        t.classList.add(X), t.addEventListener("animationend", e);
      }),
      this.hasDiscountBlock) &&
        (null === (e = this.discountErrorMessage) || void 0 === e || e.classList.add("hidden"));
    }
    cartUpdateEvents() {
      (this.items = document.querySelectorAll(it.item)),
        this.items.forEach((t) => {
          t.addEventListener("theme:cart:update", (e) => {
            this.updateCart({ id: e.detail.id, quantity: e.detail.quantity }, t);
          });
        });
    }
    cartRemoveEvents() {
      document.querySelectorAll(it.cartItemRemove).forEach((t) => {
        const e = t.closest(it.item);
        t.addEventListener("click", (s) => {
          s.preventDefault(), t.classList.contains(V) || this.updateCart({ id: t.dataset.id, quantity: 0 }, e);
        });
      }),
        this.cartCloseErrorMessage &&
          this.cartCloseErrorMessage.addEventListener("click", (t) => {
            t.preventDefault(), this.cartErrorHolder.classList.remove(Z);
          });
    }
    cartAddEvent(t) {
      let e = "",
        s = t.detail.button;
      if (s.hasAttribute("disabled")) return;
      const i = s.form || s.closest("form");
      if (!i.checkValidity()) return void i.reportValidity();
      if (((e = new FormData(i)), null !== i && i.querySelector('[type="file"]'))) return;
      "drawer" === theme.settings.cartType && this.cartDrawer && t.preventDefault();
      const o = i.getAttribute(vt),
        n = i.getAttribute(gt);
      (this.showCannotAddMoreInCart = !1),
        "true" === o && "cart" === n && (this.showCannotAddMoreInCart = !0),
        this.addToCart(e, s);
    }
    bindDiscountEventListeners() {
      this.hasDiscountBlock &&
        ((this.discounts = document.querySelectorAll(it.discountBody)),
        this.discounts.forEach((t) => {
          const e = t.dataset.discountCode;
          this.existingDiscountCodes.includes(e) || this.existingDiscountCodes.push(e);
          const s = t.querySelector(it.removeDiscount);
          s &&
            (s.removeEventListener("click", this.handleRemoveDiscount),
            s.addEventListener("click", (t) => {
              t.preventDefault(), this.removeDiscount(e);
            }));
        }));
    }
    applyDiscount(t) {
      if (this.existingDiscountCodes.includes(t))
        return (
          this.discountErrorMessage.classList.remove("hidden"),
          void (this.discountErrorMessage.textContent = window.theme.strings.discount_already_applied)
        );
      this.existingDiscountCodes.push(t), this.updateCartDiscounts(this.existingDiscountCodes.join(","));
    }
    removeDiscount(t) {
      this.existingDiscountCodes.includes(t) &&
        ((this.existingDiscountCodes = this.existingDiscountCodes.filter((e) => e !== t)),
        this.updateCartDiscounts(this.existingDiscountCodes.join(",")));
    }
    updateCartDiscounts(t) {
      var e;
      const s =
        null ===
          (e = t
            .split(",")
            .filter((t) => t)
            .pop()) || void 0 === e
          ? void 0
          : e.trim();
      this.disableCartButtons(),
        this.discountErrorMessage.classList.add("hidden"),
        fetch(window.theme.routes.cart_update_url, {
          method: "POST",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify({ discount: t }),
        })
          .then((t) => {
            if (!t.ok) throw new Error(`HTTP error! status: ${t.status}`);
            return t.text();
          })
          .then((t) => {
            let e;
            try {
              e = JSON.parse(t);
            } catch (e) {
              throw (
                (console.error("Failed to parse cart update response:", t),
                new Error("Invalid JSON response from server."))
              );
            }
            if (s) {
              e.discount_codes &&
              Array.isArray(e.discount_codes) &&
              e.discount_codes.some((t) => t.code === s && t.applicable)
                ? (this.discountError = !1)
                : ((this.discountError = !0),
                  (this.existingDiscountCodes = this.existingDiscountCodes.filter((t) => t !== s)));
            } else this.discountError = !1;
            this.getCart();
          })
          .catch((t) => {
            console.log(t);
          });
    }
    cartEvents() {
      this.cartTermsCheckbox &&
        (this.cartTermsCheckbox.removeEventListener("change", this.formSubmitHandler),
        this.cartCheckoutButtonWrapper.removeEventListener("click", this.formSubmitHandler),
        this.cartForm.removeEventListener("submit", this.formSubmitHandler),
        this.cartTermsCheckbox.addEventListener("change", this.formSubmitHandler),
        this.cartCheckoutButtonWrapper.addEventListener("click", this.formSubmitHandler),
        this.cartForm.addEventListener("submit", this.formSubmitHandler));
    }
    formSubmitHandler() {
      const t = document.querySelector(it.cartTermsCheckbox).checked,
        e = document.querySelector(it.termsErrorMessage);
      if (t) e.classList.remove(Z), this.cartCheckoutButton.removeAttribute(nt);
      else {
        if (document.querySelector(it.termsErrorMessage).length > 0) return;
        (e.innerText = theme.strings.cartAcceptanceError),
          this.cartCheckoutButton.setAttribute(nt, !0),
          e.classList.add(Z);
      }
    }
    formErrorsEvents(t) {
      const e = t.querySelector(it.formCloseError);
      null == e ||
        e.addEventListener("click", (e) => {
          e.preventDefault(), t && t.classList.remove(J);
        });
    }
    getCart() {
      fetch(theme.routes.cart_url + "?section_id=api-cart-items")
        .then(this.cartErrorsHandler)
        .then((t) => t.text())
        .then((t) => {
          const e = document.createElement("div");
          e.innerHTML = t;
          const s = e.querySelector(it.apiContent);
          this.build(s);
        })
        .catch((t) => console.log(t));
    }
    addToCart(t, e) {
      this.cart && this.cart.classList.add(K);
      const s = null == e ? void 0 : e.closest(it.quickAddHolder);
      e && (e.classList.add(K), (e.disabled = !0)),
        s && s.classList.add(J),
        fetch(theme.routes.cart_add_url, {
          method: "POST",
          headers: { "X-Requested-With": "XMLHttpRequest", Accept: "application/javascript" },
          body: t,
        })
          .then((t) => t.json())
          .then((t) => {
            (t.status &&
              (this.addToCartError(t, e),
              e && (e.classList.remove(K), (e.disabled = !1)),
              !this.showCannotAddMoreInCart)) ||
              (this.cart
                ? (e &&
                    (e.classList.remove(K),
                    e.classList.add(U),
                    e.dispatchEvent(
                      new CustomEvent("theme:product:add", { detail: { response: t, button: e }, bubbles: !0 })
                    )),
                  "page" === theme.settings.cartType && (window.location = theme.routes.cart_url),
                  this.getCart())
                : (window.location = theme.routes.cart_url));
          })
          .catch((t) => {
            this.addToCartError(t, e), this.enableCartButtons();
          });
    }
    updateCart(t = {}, e = null) {
      this.cart.classList.add(K);
      let s = t.quantity;
      null !== e && (s ? e.classList.add(K) : e.classList.add(Y)), this.disableCartButtons();
      const i = this.cart.querySelector(`[${lt}="${t.id}"]`) || e,
        o = (null == i ? void 0 : i.hasAttribute(dt)) ? parseInt(i.getAttribute(dt)) : 0,
        n = (null == i ? void 0 : i.hasAttribute(ct)) ? i.getAttribute(ct) : null;
      if (0 === o) return;
      const r = { line: o, quantity: s };
      fetch(theme.routes.cart_change_url, {
        method: "post",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify(r),
      })
        .then((t) => t.text())
        .then((t) => {
          if (JSON.parse(t).errors)
            return (
              (this.cartUpdateFailed = !0),
              this.updateErrorText(n),
              this.toggleErrorMessage(),
              this.resetLineItem(e),
              this.enableCartButtons(),
              void this.bindDiscountEventListeners()
            );
          this.getCart();
        })
        .catch((t) => {
          console.log(t), this.enableCartButtons();
        });
    }
    resetLineItem(t) {
      const e = t.querySelector(it.qtyInput),
        s = e.getAttribute("value");
      (e.value = s), t.classList.remove(K);
    }
    disableCartButtons() {
      const t = this.cart.querySelectorAll("input"),
        e = this.cart.querySelectorAll(`button, ${it.cartItemRemove}`);
      t.length &&
        t.forEach((t) => {
          t.classList.add(V), t.blur(), (t.disabled = !0);
        }),
        e.length &&
          e.forEach((t) => {
            t.setAttribute(nt, !0);
          });
    }
    enableCartButtons() {
      const t = this.cart.querySelectorAll("input"),
        e = this.cart.querySelectorAll(`button, ${it.cartItemRemove}`);
      t.length &&
        t.forEach((t) => {
          t.classList.remove(V), (t.disabled = !1);
        }),
        e.length &&
          e.forEach((t) => {
            t.removeAttribute(nt);
          }),
        this.cart.classList.remove(K);
    }
    updateErrorText(t) {
      this.cartErrorHolder.querySelector(it.errorMessage).innerText = t;
    }
    toggleErrorMessage() {
      this.cartErrorHolder &&
        (this.cartErrorHolder.classList.toggle(Z, this.cartUpdateFailed || this.showCannotAddMoreInCart),
        (this.showCannotAddMoreInCart = !1),
        (this.cartUpdateFailed = !1));
    }
    cartErrorsHandler(t) {
      return t.ok
        ? t
        : t.json().then(function (e) {
            throw new W({ status: t.statusText, headers: t.headers, json: e });
          });
    }
    hideAddToCartErrorMessage() {
      const t = this.button.closest(it.upsellHolder)
          ? this.button.closest(it.upsellHolder)
          : this.button.closest(it.productForm),
        e = null == t ? void 0 : t.querySelector(it.formErrorsContainer);
      null == e || e.classList.remove(J);
    }
    addToCartError(t, e) {
      var s;
      if (this.showCannotAddMoreInCart) return;
      if (null !== e) {
        const s = e.closest(it.outerSection) || e.closest(it.quickAddHolder) || e.closest(it.quickAddModal);
        let i = null == s ? void 0 : s.querySelector(it.formErrorsContainer);
        const o = e.closest(it.quickAddHolder);
        if ((o && o.querySelector(it.formErrorsContainer) && (i = o.querySelector(it.formErrorsContainer)), i)) {
          let e = `${t.message}: ${t.description}`;
          t.message == t.description && (e = t.message),
            (i.innerHTML = `<div class="errors">${e}<button type="button" class="errors__close" data-close-error><svg aria-hidden="true" focusable="false" role="presentation" width="24px" height="24px" stroke-width="1" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" color="currentColor" class="icon icon-cancel"><path d="M6.758 17.243L12.001 12m5.243-5.243L12 12m0 0L6.758 6.757M12.001 12l5.243 5.243" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"></path></svg></button></div>`),
            i.classList.add(J),
            this.formErrorsEvents(i);
        }
        e.dispatchEvent(
          new CustomEvent("theme:product:add-error", { detail: { response: t, button: e }, bubbles: !0 })
        );
      }
      const i = null == e ? void 0 : e.closest(it.quickAddHolder);
      i &&
        i.dispatchEvent(
          new CustomEvent("theme:cart:error", {
            bubbles: !0,
            detail: { message: t.message, description: t.description, holder: i },
          })
        ),
        null === (s = this.cart) || void 0 === s || s.classList.remove(K);
    }
    productAddCallback(t) {
      let e = [],
        s = null;
      const i = "theme:product:add-error" == t.type,
        o = t.detail.button,
        n = document.querySelector(it.cartBarAdd);
      e.push(o),
        (s = o.closest(it.quickAddHolder)),
        n && e.push(n),
        e.forEach((t) => {
          t.classList.remove(K), i || t.classList.add(U);
        }),
        setTimeout(() => {
          e.forEach((t) => {
            var e, s;
            t.classList.remove(U);
            (null === (e = t.closest(it.formWrapper)) || void 0 === e ? void 0 : e.classList.contains(et)) ||
              (null === (s = t.closest(it.formWrapper)) || void 0 === s ? void 0 : s.classList.contains(st)) ||
              (t.disabled = !1);
          }),
            null == s || s.classList.remove(J);
        }, 1e3);
    }
    toggleClassesOnContainers() {
      const t = this.hasItemsInCart();
      this.cart.classList.toggle(z, !t),
        !t &&
          this.cartDrawer &&
          setTimeout(() => {
            this.a11y.trapFocus(this.cartDrawer, { elementToFocus: this.cartDrawer.querySelector(it.cartDrawerClose) });
          }, 100);
    }
    build(t) {
      var e;
      const s = t.querySelector(it.apiLineItems),
        i = t.querySelector(it.apiUpsellItems),
        o = t.querySelector(it.apiBundleItems),
        n = Boolean(null === s && null === i && null === o),
        r = t.querySelector(it.apiCartPrice),
        a = t.querySelector(it.cartTotal);
      this.priceHolder && r && (this.priceHolder.innerHTML = r.innerHTML),
        n
          ? ((this.itemsHolder.innerHTML = t.innerHTML),
            this.upsellProductsHolder && (this.upsellProductsHolder.innerHTML = ""),
            this.bundleProductsHolder && (this.bundleProductsHolder.innerHTML = ""))
          : ((this.itemsHolder.innerHTML = s.innerHTML),
            this.upsellProductsHolder && (this.upsellProductsHolder.innerHTML = i.innerHTML),
            this.bundleProductsHolder && (this.bundleProductsHolder.innerHTML = o.innerHTML),
            this.skipUpsellOrBundleProductEvent(),
            this.checkSkippedUpsellOrBundleProductsFromStorage(),
            this.toggleCartUpsellOrBundleWidgetVisibility()),
        (this.newTotalItems = s && s.querySelectorAll(it.item).length ? s.querySelectorAll(it.item).length : 0),
        (this.subtotal = a && a.hasAttribute(ot) ? parseInt(a.getAttribute(ot)) : 0),
        (this.cartCount = this.getCartItemCount()),
        document.dispatchEvent(
          new CustomEvent("theme:cart:change", { bubbles: !0, detail: { cartCount: this.cartCount } })
        ),
        (this.cartTotal.innerHTML =
          0 === this.subtotal
            ? window.theme.strings.free
            : window.theme.formatMoney(this.subtotal, theme.moneyWithCurrencyFormat)),
        this.totalItems !== this.newTotalItems &&
          ((this.totalItems = this.newTotalItems), this.toggleClassesOnContainers()),
        (null === (e = this.cartDrawer) || void 0 === e ? void 0 : e.classList.contains(Q)) &&
          this.cart.classList.add(tt),
        this.cart.classList.remove(K),
        this.hasItemsInCart() ||
          this.cartEmpty.querySelectorAll(it.animation).forEach((t) => {
            t.classList.remove(N);
          }),
        this.hasDiscountBlock &&
          (this.discountField && (this.discountField.value = this.existingDiscountCodes.join(",")),
          this.discountError
            ? ((this.discountErrorMessage.textContent = window.theme.strings.discount_not_applicable),
              this.discountErrorMessage.classList.remove("hidden"))
            : this.discountErrorMessage.classList.add("hidden")),
        this.freeShippingMessageHandle(this.subtotal),
        this.cartRemoveEvents(),
        this.cartUpdateEvents(),
        this.toggleErrorMessage(),
        this.enableCartButtons(),
        this.updateProgress(),
        this.animateItems(),
        this.bindDiscountEventListeners(),
        document.dispatchEvent(new CustomEvent("theme:product:added", { bubbles: !0 }));
    }
    getCartItemCount() {
      return Array.from(this.cart.querySelectorAll(it.qtyInput)).reduce((t, e) => t + parseInt(e.value), 0);
    }
    hasItemsInCart() {
      return this.totalItems > 0;
    }
    freeShippingMessageHandle(t) {
      this.freeShipping.length &&
        this.freeShipping.forEach((e) => {
          const s = e.hasAttribute(rt) && "true" === e.getAttribute(rt) && t >= 0;
          e.classList.toggle(G, s && t >= this.freeShippingLimit);
        });
    }
    updateProgress() {
      if (((this.freeShipping = document.querySelectorAll(it.freeShipping)), !this.freeShipping.length)) return;
      const t = isNaN(this.subtotal / this.freeShippingLimit) ? 100 : this.subtotal / this.freeShippingLimit,
        e = Math.min(100 * t, 100),
        s = this.circumference - ((e / 100) * this.circumference) / 2,
        i = window.theme.formatMoney(this.freeShippingLimit - this.subtotal, theme.moneyFormat);
      this.freeShipping.forEach((t) => {
        const o = t.querySelector(it.freeShippingProgress),
          n = t.querySelector(it.freeShippingGraph),
          r = t.querySelector(it.leftToSpend);
        r && (r.innerHTML = i.replace(".00", "")),
          o && (o.value = e),
          n && n.style.setProperty("--stroke-dashoffset", `${s}`);
      });
    }
    skipUpsellOrBundleProductEvent() {
      var t, e;
      if (null === this.upsellProductsHolder && null === this.bundleProductsHolder) return;
      const s = [
        ...((null === (t = this.upsellProductsHolder) || void 0 === t
          ? void 0
          : t.querySelectorAll(it.buttonSkipUpsellProduct)) || []),
        ...((null === (e = this.bundleProductsHolder) || void 0 === e
          ? void 0
          : e.querySelectorAll(it.buttonSkipUpsellProduct)) || []),
      ];
      s.length &&
        s.forEach((t) => {
          t.addEventListener("click", (e) => {
            e.preventDefault();
            const s = t.closest(it.quickAddHolder).getAttribute(ut),
              i = !!t.closest(it.upsellWidget),
              o = !!t.closest(it.bundleWidget);
            i &&
              !this.skipUpsellProductsArray.includes(s) &&
              (this.skipUpsellProductsArray.push(s),
              window.sessionStorage.setItem("skip_upsell_products", this.skipUpsellProductsArray),
              this.removeUpsellOrBundleProduct(s, "upsell")),
              o &&
                !this.skipBundleProductsArray.includes(s) &&
                (this.skipBundleProductsArray.push(s),
                window.sessionStorage.setItem("skip_bundle_products", this.skipBundleProductsArray),
                this.removeUpsellOrBundleProduct(s, "bundle")),
              this.toggleCartUpsellOrBundleWidgetVisibility();
          });
        });
    }
    checkSkippedUpsellOrBundleProductsFromStorage() {
      [
        { key: "upsell", storageKey: "skip_upsell_products", array: this.skipUpsellProductsArray },
        { key: "bundle", storageKey: "skip_bundle_products", array: this.skipBundleProductsArray },
      ].forEach(({ key: t, storageKey: e, array: s }) => {
        const i = window.sessionStorage.getItem(e);
        i &&
          i.split(",").forEach((e) => {
            s.includes(e) || s.push(e), this.removeUpsellOrBundleProduct(e, t);
          });
      });
    }
    removeUpsellOrBundleProduct(t, e = "upsell") {
      const s = { upsell: this.upsellProductsHolder, bundle: this.bundleProductsHolder }[e];
      if (!s) return;
      const i = s.querySelector(`[${ut}="${t}"]`);
      i && i.parentNode && i.parentNode.remove();
    }
    toggleCartUpsellOrBundleWidgetVisibility() {
      var t, e, s, i;
      if (!this.upsellProductsHolder && !this.bundleProductsHolder) return;
      const o =
          null === (t = this.upsellProductsHolder) || void 0 === t ? void 0 : t.querySelectorAll(it.quickAddHolder),
        n = null === (e = this.bundleProductsHolder) || void 0 === e ? void 0 : e.querySelectorAll(it.quickAddHolder),
        r = null === (s = this.upsellProductsHolder) || void 0 === s ? void 0 : s.closest(it.upsellWidget),
        a = null === (i = this.bundleProductsHolder) || void 0 === i ? void 0 : i.closest(it.bundleWidget);
      if (!r && !a) return;
      const l = (t, e, s) => {
        if (t && (t.classList.toggle(j, !e.length), e.length && !t.hasAttribute(ht) && t.hasAttribute(s))) {
          t.setAttribute(ht, !0);
          const e = t.querySelector(it.collapsibleBody);
          e && (e.style.height = "auto");
        }
      };
      l(r, o, pt), l(a, n, pt);
    }
    resetAnimatedItems() {
      this.cart.querySelectorAll(it.animation).forEach((t) => {
        t.classList.remove(N), t.classList.remove(X);
      });
    }
    animateItems(t) {
      requestAnimationFrame(() => {
        let e = this.cart;
        t && t.detail && t.detail.target && (e = t.detail.target),
          null == e ||
            e.querySelectorAll(it.animation).forEach((t) => {
              t.classList.add(N);
            });
      });
    }
    constructor() {
      super(), (this.a11y = window.theme.a11y);
    }
  };
  customElements.get("cart-items") || customElements.define("cart-items", bt);
  const wt = "data-cart-count",
    yt = "data-limit";
  let Et = class extends HTMLElement {
    connectedCallback() {
      document.addEventListener("theme:cart:change", this.onCartChangeCallback);
    }
    disconnectedCallback() {
      document.addEventListener("theme:cart:change", this.onCartChangeCallback);
    }
    onCartChange(t) {
      (this.cartCount = t.detail.cartCount), this.update();
    }
    update() {
      if (null !== this.cartCount) {
        this.setAttribute(wt, this.cartCount);
        let t = this.cartCount;
        this.limit && this.cartCount >= this.limit && (t = "9+"), (this.innerText = t);
      }
    }
    constructor() {
      super(),
        (this.cartCount = null),
        (this.limit = this.getAttribute(yt)),
        (this.onCartChangeCallback = this.onCartChange.bind(this));
    }
  };
  customElements.get("cart-count") || customElements.define("cart-count", Et);
  const ft = "is-open",
    Lt = "is-closing",
    St = "drawer--duplicate",
    At = "drawer-editor-error",
    kt = ".additional-checkout-buttons",
    Ct = "cart-drawer",
    qt = "[data-cart-drawer-close]",
    Tt = "[data-cart-drawer-inner]",
    Mt = ".shopify-section",
    xt = "data-drawer-underlay";
  let Ht = class extends HTMLElement {
    connectedCallback() {
      const t = this.closest(Mt);
      if (window.theme.hasCartDrawer) {
        if (!window.Shopify.designMode) return void t.remove();
        {
          const t = document.createElement("div");
          t.classList.add(At),
            (t.innerText = "Cart drawer section already exists."),
            this.querySelector(`.${At}`) || this.querySelector(Tt).append(t),
            this.classList.add(St);
        }
      }
      (window.theme.hasCartDrawer = !0),
        this.addEventListener("theme:cart-drawer:show", this.openCartDrawer),
        document.addEventListener("theme:cart:toggle", this.toggleCartDrawer),
        document.addEventListener("theme:quick-add:open", this.closeCartDrawer),
        document.addEventListener("theme:product:added", this.openCartDrawerOnProductAdded),
        document.addEventListener("shopify:block:select", this.openCartDrawerOnSelect),
        document.addEventListener("shopify:section:select", this.openCartDrawerOnSelect),
        document.addEventListener("shopify:section:deselect", this.closeCartDrawerOnDeselect);
    }
    disconnectedCallback() {
      document.removeEventListener("theme:product:added", this.openCartDrawerOnProductAdded),
        document.removeEventListener("theme:cart:toggle", this.toggleCartDrawer),
        document.removeEventListener("theme:quick-add:open", this.closeCartDrawer),
        document.removeEventListener("shopify:block:select", this.openCartDrawerOnSelect),
        document.removeEventListener("shopify:section:select", this.openCartDrawerOnSelect),
        document.removeEventListener("shopify:section:deselect", this.closeCartDrawerOnDeselect),
        document.querySelectorAll(Ct).length <= 1 && (window.theme.hasCartDrawer = !1),
        c();
    }
    openCartDrawerOnProductAdded() {
      this.cartDrawerIsOpen || this.openCartDrawer();
    }
    openCartDrawerOnSelect(t) {
      (t.target.querySelector(Mt) || t.target.closest(Mt) || t.target) === this.cartDrawerSection &&
        this.openCartDrawer(!0);
    }
    closeCartDrawerOnDeselect() {
      this.cartDrawerIsOpen && this.closeCartDrawer();
    }
    openCartDrawer(t = !1) {
      (!t && this.classList.contains(St)) ||
        ((this.cartDrawerIsOpen = !0),
        (this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this)),
        document.body.addEventListener("click", this.onBodyClickEvent),
        document.dispatchEvent(new CustomEvent("theme:cart-drawer:open", { detail: { target: this }, bubbles: !0 })),
        document.dispatchEvent(new CustomEvent("theme:scroll:lock", { bubbles: !0 })),
        this.classList.add(ft),
        this.observeAdditionalCheckoutButtons(),
        window.theme.waitForAnimationEnd(this.cartDrawerInner).then(() => {
          this.a11y.trapFocus(this, { elementToFocus: this.querySelector(qt) });
        }));
    }
    closeCartDrawer() {
      this.classList.contains(ft) &&
        (this.classList.add(Lt),
        this.classList.remove(ft),
        (this.cartDrawerIsOpen = !1),
        document.dispatchEvent(new CustomEvent("theme:cart-drawer:close", { bubbles: !0 })),
        this.a11y.removeTrapFocus(),
        this.a11y.autoFocusLastElement(),
        document.body.removeEventListener("click", this.onBodyClickEvent),
        document.dispatchEvent(new CustomEvent("theme:scroll:unlock", { bubbles: !0 })),
        window.theme.waitForAnimationEnd(this.cartDrawerInner).then(() => {
          this.classList.remove(Lt);
        }));
    }
    toggleCartDrawer() {
      this.cartDrawerIsOpen ? this.closeCartDrawer() : this.openCartDrawer();
    }
    closeCartEvents() {
      this.cartDrawerClose.addEventListener("click", (t) => {
        t.preventDefault(), this.closeCartDrawer();
      }),
        this.addEventListener("keyup", (t) => {
          "Escape" === t.code && this.closeCartDrawer();
        });
    }
    onBodyClick(t) {
      t.target.hasAttribute(xt) && this.closeCartDrawer();
    }
    observeAdditionalCheckoutButtons() {
      const t = this.querySelector(kt);
      if (t) {
        const e = new MutationObserver(() => {
          this.a11y.trapFocus(this, { elementToFocus: this.querySelector(qt) }), e.disconnect();
        });
        e.observe(t, { subtree: !0, childList: !0 });
      }
    }
    constructor() {
      super(),
        (this.cartDrawerIsOpen = !1),
        (this.cartDrawerClose = this.querySelector(qt)),
        (this.cartDrawerInner = this.querySelector(Tt)),
        (this.openCartDrawer = this.openCartDrawer.bind(this)),
        (this.closeCartDrawer = this.closeCartDrawer.bind(this)),
        (this.toggleCartDrawer = this.toggleCartDrawer.bind(this)),
        (this.openCartDrawerOnProductAdded = this.openCartDrawerOnProductAdded.bind(this)),
        (this.openCartDrawerOnSelect = this.openCartDrawerOnSelect.bind(this)),
        (this.closeCartDrawerOnDeselect = this.closeCartDrawerOnDeselect.bind(this)),
        (this.cartDrawerSection = this.closest(Mt)),
        (this.a11y = window.theme.a11y),
        this.closeCartEvents();
    }
  };
  customElements.get("cart-drawer") || customElements.define("cart-drawer", Ht);
  let It = class extends HTMLElement {
    connectedCallback() {
      (this.collapsibles = this.querySelectorAll("[data-collapsible]")),
        this.toggle(),
        document.addEventListener("theme:resize:width", this.toggle),
        this.collapsibles.forEach((t) => {
          const e = t.querySelector("[data-collapsible-trigger]"),
            s = t.querySelector("[data-collapsible-body]");
          null == e || e.addEventListener("click", this.onCollapsibleClickEvent),
            null == s || s.addEventListener("transitionend", this.onTransitionEndEvent);
        });
    }
    disconnectedCallback() {
      document.removeEventListener("theme:resize:width", this.toggle),
        this.collapsibles &&
          this.collapsibles.forEach((t) => {
            const e = t.querySelector("[data-collapsible-trigger]"),
              s = t.querySelector("[data-collapsible-body]");
            null == e || e.removeEventListener("click", this.onCollapsibleClickEvent),
              null == s || s.removeEventListener("transitionend", this.onTransitionEndEvent);
          }),
        (this.collapsibles = null);
    }
    toggle() {
      const t = !window.theme.isMobile();
      this.collapsibles.forEach((e) => {
        if (!e.hasAttribute("desktop") && !e.hasAttribute("mobile")) return;
        const s = e.hasAttribute("desktop") ? e.getAttribute("desktop") : "true",
          i = e.hasAttribute("mobile") ? e.getAttribute("mobile") : "true",
          o = (t && "true" == s) || (!t && "true" == i),
          n = e.querySelector("[data-collapsible-body]");
        o
          ? (e.removeAttribute("disabled"),
            e.querySelector("[data-collapsible-trigger]").removeAttribute("tabindex"),
            e.removeAttribute("open"),
            this.setBodyHeight(n, ""))
          : (e.setAttribute("disabled", ""),
            e.setAttribute("open", !0),
            e.querySelector("[data-collapsible-trigger]").setAttribute("tabindex", -1));
      });
    }
    open(t) {
      if ("true" == t.getAttribute("open")) return;
      const e = t.querySelector("[data-collapsible-body]"),
        s = t.querySelector("[data-collapsible-content]");
      t.setAttribute("open", !0), this.setBodyHeight(e, s.offsetHeight);
    }
    close(t) {
      if (!t.hasAttribute("open")) return;
      const e = t.querySelector("[data-collapsible-body]"),
        s = t.querySelector("[data-collapsible-content]");
      this.setBodyHeight(e, s.offsetHeight),
        t.setAttribute("open", !1),
        setTimeout(() => {
          requestAnimationFrame(() => {
            this.setBodyHeight(e, 0);
          });
        });
    }
    setBodyHeight(t, e) {
      t.style.height = "auto" !== e && "" !== e ? `${e}px` : e;
    }
    onTransitionEnd(t) {
      const e = t.target,
        s = e.closest("[data-collapsible]"),
        i = s.querySelector("[data-collapsible-body]");
      e === i &&
        s &&
        ("true" == s.getAttribute("open") && this.setBodyHeight(i, "auto"),
        "false" == s.getAttribute("open") && (s.removeAttribute("open"), this.setBodyHeight(i, "")));
    }
    onCollapsibleClick(t) {
      t.preventDefault();
      const e = t.target.closest("[data-collapsible]");
      this.single &&
        this.collapsibles.forEach((t) => {
          t.hasAttribute("open") &&
            t != e &&
            requestAnimationFrame(() => {
              this.close(t);
            });
        }),
        e.hasAttribute("open") ? this.close(e) : this.open(e),
        e.dispatchEvent(new CustomEvent("theme:form:sticky", { bubbles: !0, detail: { element: "accordion" } })),
        e.dispatchEvent(new CustomEvent("theme:collapsible:toggle", { bubbles: !0 }));
    }
    constructor() {
      super(),
        (this.single = this.hasAttribute("single")),
        (this.toggle = this.toggle.bind(this)),
        (this.onCollapsibleClickEvent = this.onCollapsibleClick.bind(this)),
        (this.onTransitionEndEvent = this.onTransitionEnd.bind(this));
    }
  };
  customElements.get("collapsible-elements") || customElements.define("collapsible-elements", It);
  let Pt = class extends HTMLElement {
    loadContent(t = !0) {
      if ((window.theme.pauseAllMedia(), !this.getAttribute("loaded"))) {
        const e = document.createElement("div");
        e.appendChild(this.querySelector("template").content.firstElementChild.cloneNode(!0)),
          this.setAttribute("loaded", !0);
        const s = this.appendChild(e.querySelector("video, model-viewer, iframe"));
        t && s.focus(), "VIDEO" == s.nodeName && s.getAttribute("autoplay") && s.play();
      }
    }
    constructor() {
      super();
      const t = this.querySelector("[data-deferred-media-button]");
      null == t || t.addEventListener("click", this.loadContent.bind(this));
    }
  };
  customElements.get("deferred-media") || customElements.define("deferred-media", Pt),
    (window.theme.DeferredMedia = window.theme.DeferredMedia || Pt);
  const Dt = "is-visible";
  class Ot {
    init() {
      var t;
      const e = { root: this.container, threshold: [0.01, 0.5, 0.75, 0.99] };
      (this.observer = new IntersectionObserver((t) => {
        t.forEach((t) => {
          t.intersectionRatio >= 0.99 ? t.target.classList.add(Dt) : t.target.classList.remove(Dt);
        });
      }, e)),
        null === (t = this.container.querySelectorAll(this.itemSelector)) ||
          void 0 === t ||
          t.forEach((t) => {
            this.observer.observe(t);
          });
    }
    destroy() {
      this.observer.disconnect();
    }
    constructor(t, e) {
      t && e && ((this.observer = null), (this.container = t), (this.itemSelector = e), this.init());
    }
  }
  const Ft = "is-dragging",
    Bt = "is-enabled",
    $t = "is-scrolling",
    _t = "is-visible",
    Rt = "[data-grid-item]";
  class Wt {
    handleMouseDown(t) {
      t.preventDefault(),
        (this.isDown = !0),
        (this.startX = t.pageX - this.slider.offsetLeft),
        (this.scrollLeft = this.slider.scrollLeft),
        this.cancelMomentumTracking();
    }
    handleMouseLeave() {
      this.isDown && ((this.isDown = !1), this.beginMomentumTracking());
    }
    handleMouseUp() {
      (this.isDown = !1), this.beginMomentumTracking();
    }
    handleMouseMove(t) {
      if (!this.isDown) return;
      t.preventDefault();
      const e = 1 * (t.pageX - this.slider.offsetLeft - this.startX),
        s = this.slider.scrollLeft,
        i = e > 0 ? 1 : -1;
      this.slider.classList.add(Ft, $t),
        (this.slider.scrollLeft = this.scrollLeft - e),
        this.slider.scrollLeft !== s && (this.velX = this.slider.scrollLeft - s || i);
    }
    handleMouseWheel() {
      this.cancelMomentumTracking(), this.slider.classList.remove($t);
    }
    beginMomentumTracking() {
      (this.isScrolling = !1), this.slider.classList.remove(Ft), this.cancelMomentumTracking(), this.scrollToSlide();
    }
    cancelMomentumTracking() {
      cancelAnimationFrame(this.scrollAnimation);
    }
    scrollToSlide() {
      if (!this.velX && !this.isScrolling) return;
      const t = this.slider.querySelector(`${Rt}.${_t}`);
      if (!t) return;
      const e = parseInt(window.getComputedStyle(t).marginRight) || 0,
        s = t.offsetWidth + e,
        i = t.offsetLeft,
        o = this.velX > 0 ? 1 : -1,
        n = Math.floor(Math.abs(this.velX) / 100) || 1;
      (this.startPosition = this.slider.scrollLeft),
        (this.distance = i - this.startPosition),
        (this.startTime = performance.now()),
        (this.isScrolling = !0),
        o < 0 && this.velX < s && (this.distance -= s * n),
        o > 0 && this.velX < s && (this.distance += s * n),
        (this.scrollAnimation = requestAnimationFrame(this.scrollStep));
    }
    scrollStep() {
      const t = performance.now() - this.startTime,
        e = parseFloat(this.easeOutCubic(Math.min(t, this.duration))).toFixed(1);
      (this.slider.scrollLeft = e),
        t < this.duration
          ? (this.scrollAnimation = requestAnimationFrame(this.scrollStep))
          : (this.slider.classList.remove($t), (this.velX = 0), (this.isScrolling = !1));
    }
    easeOutCubic(t) {
      return (t /= this.duration), t--, this.distance * (t * t * t + 1) + this.startPosition;
    }
    destroy() {
      this.slider.classList.remove(Bt),
        this.slider.removeEventListener("mousedown", this.handleMouseDown),
        this.slider.removeEventListener("mouseleave", this.handleMouseLeave),
        this.slider.removeEventListener("mouseup", this.handleMouseUp),
        this.slider.removeEventListener("mousemove", this.handleMouseMove),
        this.slider.removeEventListener("wheel", this.handleMouseWheel);
    }
    constructor(t) {
      (this.slider = t),
        (this.isDown = !1),
        (this.startX = 0),
        (this.scrollLeft = 0),
        (this.velX = 0),
        (this.scrollAnimation = null),
        (this.isScrolling = !1),
        (this.duration = 800),
        (this.scrollStep = this.scrollStep.bind(this)),
        (this.scrollToSlide = this.scrollToSlide.bind(this)),
        (this.handleMouseDown = this.handleMouseDown.bind(this)),
        (this.handleMouseLeave = this.handleMouseLeave.bind(this)),
        (this.handleMouseUp = this.handleMouseUp.bind(this)),
        (this.handleMouseMove = this.handleMouseMove.bind(this)),
        (this.handleMouseWheel = this.handleMouseWheel.bind(this)),
        this.slider.addEventListener("mousedown", this.handleMouseDown),
        this.slider.addEventListener("mouseleave", this.handleMouseLeave),
        this.slider.addEventListener("mouseup", this.handleMouseUp),
        this.slider.addEventListener("mousemove", this.handleMouseMove),
        this.slider.addEventListener("wheel", this.handleMouseWheel, { passive: !0 }),
        this.slider.classList.add(Bt);
    }
  }
  customElements.get("grid-slider") ||
    customElements.define(
      "grid-slider",
      class extends HTMLElement {
        connectedCallback() {
          this.init(), this.addEventListener("theme:grid-slider:init", this.init);
        }
        init() {
          (this.slider = this.querySelector("[data-grid-slider]")),
            (this.slides = this.querySelectorAll("[data-grid-item]")),
            (this.buttons = this.querySelectorAll("[data-button-arrow]")),
            this.slider.classList.add("scroll-snap-disabled"),
            this.toggleSlider(),
            document.addEventListener("theme:resize:width", this.toggleSlider),
            window.theme
              .waitForAllAnimationsEnd(this)
              .then(() => {
                this.slider.classList.remove("scroll-snap-disabled");
              })
              .catch(() => {
                this.slider.classList.remove("scroll-snap-disabled");
              });
        }
        toggleSlider() {
          if (!(this.slider.clientWidth < this.getSlidesWidth()) || (window.theme.isMobile() && window.theme.touch))
            this.destroy();
          else {
            if (this.isInitialized) return;
            (this.slidesObserver = new Ot(this.slider, "[data-grid-item]")),
              this.initArrows(),
              (this.isInitialized = !0),
              (this.draggableSlider = new Wt(this.slider));
          }
        }
        initArrows() {
          if (!this.buttons.length) {
            const t = document.createElement("div");
            t.classList.add("slider__arrows"),
              (t.innerHTML = theme.sliderArrows.prev + theme.sliderArrows.next),
              this.append(t),
              (this.buttons = this.querySelectorAll("[data-button-arrow]")),
              (this.buttonPrev = this.querySelector("[data-button-prev]")),
              (this.buttonNext = this.querySelector("[data-button-next]"));
          }
          this.toggleArrowsObserver(),
            this.hasAttribute("align-arrows") && (this.positionArrows(), this.arrowsResizeObserver()),
            this.buttons.forEach((t) => {
              t.addEventListener("click", this.onButtonArrowClick);
            });
        }
        buttonArrowClickEvent(t) {
          t.preventDefault();
          const e = this.slider.querySelector("[data-grid-item].is-visible");
          let s = null;
          t.target.hasAttribute("data-button-prev") && (s = null == e ? void 0 : e.previousElementSibling),
            t.target.hasAttribute("data-button-next") && (s = null == e ? void 0 : e.nextElementSibling),
            this.goToSlide(s);
        }
        removeArrows() {
          var t;
          null === (t = this.querySelector(".slider__arrows")) || void 0 === t || t.remove();
        }
        goToSlide(t) {
          t && this.slider.scrollTo({ top: 0, left: t.offsetLeft, behavior: "smooth" });
        }
        getSlidesWidth() {
          var t;
          return (
            (null === (t = this.slider.querySelector("[data-grid-item]")) || void 0 === t ? void 0 : t.clientWidth) *
            this.slider.querySelectorAll("[data-grid-item]").length
          );
        }
        toggleArrowsObserver() {
          if (this.buttonPrev && this.buttonNext) {
            const t = this.slides.length,
              e = this.slides[0],
              s = this.slides[t - 1],
              i = { attributes: !0, childList: !1, subtree: !1 },
              o = (t) => {
                for (const i of t)
                  if ("attributes" === i.type) {
                    const t = i.target,
                      o = Boolean(t.classList.contains("is-visible"));
                    t == e && (this.buttonPrev.disabled = o), t == s && (this.buttonNext.disabled = o);
                  }
              };
            e &&
              s &&
              ((this.firstLastSlidesObserver = new MutationObserver(o)),
              this.firstLastSlidesObserver.observe(e, i),
              this.firstLastSlidesObserver.observe(s, i));
          }
        }
        positionArrows() {
          if (this.hasAttribute("images-widths-different")) {
            const t = this.slider.querySelectorAll("figure"),
              e = Math.max(0, ...Array.from(t).map((t) => t.clientHeight));
            return void this.style.setProperty("--button-position", e / 2 + "px");
          }
          const t =
            this.slider.querySelector("[data-social-video-item]") ||
            this.slider.querySelector("[data-product-image]") ||
            this.slider.querySelector("[data-collection-image]") ||
            this.slider.querySelector("[data-column-image]") ||
            this.slider;
          t && this.style.setProperty("--button-position", t.clientHeight / 2 + "px");
        }
        arrowsResizeObserver() {
          document.addEventListener("theme:resize:width", this.positionArrows);
        }
        disconnectedCallback() {
          this.destroy(), document.removeEventListener("theme:resize:width", this.toggleSlider);
        }
        destroy() {
          var t, e;
          (this.isInitialized = !1),
            null === (t = this.draggableSlider) || void 0 === t || t.destroy(),
            (this.draggableSlider = null),
            null === (e = this.slidesObserver) || void 0 === e || e.destroy(),
            (this.slidesObserver = null),
            this.removeArrows(),
            document.removeEventListener("theme:resize:width", this.positionArrows);
        }
        constructor() {
          super(),
            (this.isInitialized = !1),
            (this.draggableSlider = null),
            (this.positionArrows = this.positionArrows.bind(this)),
            (this.onButtonArrowClick = (t) => this.buttonArrowClickEvent(t)),
            (this.slidesObserver = null),
            (this.firstLastSlidesObserver = null),
            (this.isDragging = !1),
            (this.toggleSlider = this.toggleSlider.bind(this));
        }
      }
    ),
    (window.theme.hasOpenModals = function () {
      const t = Boolean(document.querySelectorAll("dialog[open][data-scroll-lock-required]").length),
        e = Boolean(document.querySelectorAll(".drawer.is-open").length);
      return t || e;
    }),
    customElements.get("header-component") ||
      customElements.define(
        "header-component",
        class extends HTMLElement {
          connectedCallback() {
            this.killDeadLinks(),
              this.drawerToggleEvent(),
              this.cartToggleEvent(),
              this.initSticky(),
              "drawer" !== this.style && this.desktop && ((this.minWidth = this.getMinWidth()), this.listenWidth());
          }
          listenWidth() {
            "ResizeObserver" in window
              ? ((this.resizeObserver = new ResizeObserver(this.checkWidth)), this.resizeObserver.observe(this))
              : document.addEventListener("theme:resize", this.checkWidth);
          }
          drawerToggleEvent() {
            const t = this.querySelector("[data-drawer-toggle]");
            t.addEventListener("click", () => {
              document
                .querySelector("[data-drawer]")
                .dispatchEvent(new CustomEvent("theme:drawer:toggle", { bubbles: !1, detail: { button: t } }));
            });
          }
          killDeadLinks() {
            this.deadLinks.forEach((t) => {
              t.onclick = (t) => {
                t.preventDefault();
              };
            });
          }
          checkWidth() {
            if (document.body.clientWidth < this.minWidth) {
              this.classList.add("js__show__mobile");
              const { headerHeight: t } = window.theme.readHeights();
              document.documentElement.style.setProperty("--header-height", `${t}px`);
            } else this.classList.remove("js__show__mobile");
          }
          getMinWidth() {
            const t = document.createElement("div");
            t.classList.add("js__header__clone", "header-wrapper"),
              t.appendChild(this.querySelector("header").cloneNode(!0)),
              document.body.appendChild(t);
            const e = t.querySelectorAll("[data-takes-space-wrapper]");
            let s = 0,
              i = 0;
            return (
              e.forEach((t) => {
                const e = t.querySelectorAll("[data-child-takes-space]");
                let o = 0;
                (o = 3 === e.length ? this._sumSplitWidths(e) : this._sumWidths(e)),
                  o > s && ((s = o), (i = 20 * e.length));
              }),
              document.body.removeChild(t),
              s + i
            );
          }
          cartToggleEvent() {
            var t;
            "drawer" === theme.settings.cartType &&
              (null === (t = this.querySelectorAll("[data-cart-toggle]")) ||
                void 0 === t ||
                t.forEach((t) => {
                  t.addEventListener("click", (e) => {
                    const s = document.querySelector("cart-drawer");
                    s &&
                      (e.preventDefault(),
                      s.dispatchEvent(new CustomEvent("theme:cart-drawer:show")),
                      (window.a11y.lastElement = t));
                  });
                }));
          }
          initSticky() {
            var t;
            this.isSticky &&
              ((this.isStuck = !1),
              (this.cls = this.classList),
              (this.headerOffset =
                null === (t = document.querySelector(".page-header")) || void 0 === t ? void 0 : t.offsetTop),
              (this.updateHeaderOffset = this.updateHeaderOffset.bind(this)),
              (this.scrollEvent = (t) => this.onScroll(t)),
              this.listen(),
              this.stickOnLoad());
          }
          listen() {
            document.addEventListener("theme:scroll", this.scrollEvent),
              document.addEventListener("shopify:section:load", this.updateHeaderOffset),
              document.addEventListener("shopify:section:unload", this.updateHeaderOffset);
          }
          onScroll(t) {
            t.detail.down
              ? !this.isStuck && t.detail.position > this.headerOffset && this.stickSimple()
              : t.detail.position <= this.headerOffset && this.unstickSimple();
          }
          updateHeaderOffset(t) {
            t.target.classList.contains("shopify-section-group-header-group") &&
              setTimeout(() => {
                var t;
                this.headerOffset =
                  null === (t = document.querySelector(".page-header")) || void 0 === t ? void 0 : t.offsetTop;
              });
          }
          stickOnLoad() {
            window.scrollY > this.headerOffset && this.stickSimple();
          }
          stickSimple() {
            this.cls.add("js__header__stuck"), (this.isStuck = !0);
          }
          unstickSimple() {
            document.documentElement.hasAttribute("data-scroll-locked") ||
              (this.cls.remove("js__header__stuck"), (this.isStuck = !1));
          }
          _sumSplitWidths(t) {
            let e = [];
            t.forEach((t) => {
              t.firstElementChild && e.push(t.firstElementChild.clientWidth);
            }),
              e[0] > e[2] ? (e[2] = e[0]) : (e[0] = e[2]);
            return e.reduce((t, e) => t + e);
          }
          _sumWidths(t) {
            let e = 0;
            return (
              t.forEach((t) => {
                e += t.clientWidth;
              }),
              e
            );
          }
          disconnectedCallback() {
            var t;
            "ResizeObserver" in window
              ? null === (t = this.resizeObserver) || void 0 === t || t.unobserve(this)
              : document.removeEventListener("theme:resize", this.checkWidth);
            this.isSticky &&
              (document.removeEventListener("theme:scroll", this.scrollEvent),
              document.removeEventListener("shopify:section:load", this.updateHeaderOffset),
              document.removeEventListener("shopify:section:unload", this.updateHeaderOffset));
          }
          constructor() {
            super(),
              (this.style = this.dataset.style),
              (this.desktop = this.querySelector("[data-header-desktop]")),
              (this.deadLinks = document.querySelectorAll('.navlink[href="#"]')),
              (this.resizeObserver = null),
              (this.checkWidth = this.checkWidth.bind(this)),
              (this.isSticky = this.hasAttribute("data-header-sticky")),
              document.body.classList.toggle("has-header-sticky", this.isSticky);
          }
        }
      );
  const Nt = "[data-top-link]",
    Ut = "[data-header-wrapper]",
    Vt = "[data-stagger]",
    zt = "[data-stagger-first]",
    jt = "[data-stagger-second]",
    Xt = "is-visible",
    Kt = "meganav--visible",
    Qt = "meganav--is-transitioning";
  customElements.get("hover-disclosure") ||
    customElements.define(
      "hover-disclosure",
      class extends HTMLElement {
        connectedCallback() {
          this.setAttribute("aria-haspopup", !0),
            this.setAttribute("aria-expanded", !1),
            this.setAttribute("aria-controls", this.key),
            this.connectHoverToggle(),
            this.handleTablets(),
            this.staggerChildAnimations(),
            this.addEventListener("theme:disclosure:show", (t) => {
              this.showDisclosure(t);
            }),
            this.addEventListener("theme:disclosure:hide", (t) => {
              this.hideDisclosure(t);
            });
        }
        showDisclosure(t) {
          t && t.type && "mouseenter" === t.type && this.wrapper.classList.add(Qt),
            this.grandparent ? this.wrapper.classList.add(Kt) : this.wrapper.classList.remove(Kt),
            this.setAttribute("aria-expanded", !0),
            this.classList.add(Xt),
            this.disclosure.classList.add(Xt),
            this.transitionTimeout && clearTimeout(this.transitionTimeout),
            (this.transitionTimeout = setTimeout(() => {
              this.wrapper.classList.remove(Qt);
            }, 200));
        }
        hideDisclosure() {
          this.classList.remove(Xt),
            this.disclosure.classList.remove(Xt),
            this.setAttribute("aria-expanded", !1),
            this.wrapper.classList.remove(Kt, Qt);
        }
        staggerChildAnimations() {
          const t = this.querySelectorAll(Vt);
          let e = 50;
          t.forEach((t, s) => {
            (t.style.transitionDelay = s * e + 10 + "ms"), (e *= 0.95);
          });
          this.querySelectorAll(zt).forEach((t, e) => {
            const s = 100 * e;
            (t.style.transitionDelay = `${s}ms`),
              t.parentElement.querySelectorAll(jt).forEach((t, e) => {
                const i = 20 * (e + 1);
                t.style.transitionDelay = `${s + i}ms`;
              });
          });
        }
        handleTablets() {
          this.addEventListener(
            "touchstart",
            function (t) {
              this.classList.contains(Xt) || (t.preventDefault(), this.showDisclosure(t));
            }.bind(this),
            { passive: !0 }
          );
        }
        connectHoverToggle() {
          this.addEventListener("mouseenter", (t) => this.showDisclosure(t)),
            this.link.addEventListener("focus", (t) => this.showDisclosure(t)),
            this.addEventListener("mouseleave", () => this.hideDisclosure()),
            this.addEventListener("focusout", (t) => {
              this.contains(t.relatedTarget) || this.hideDisclosure();
            }),
            this.addEventListener("keyup", (t) => {
              "Escape" === t.code && this.hideDisclosure();
            });
        }
        constructor() {
          super(),
            (this.wrapper = this.closest(Ut)),
            (this.key = this.getAttribute("aria-controls")),
            (this.link = this.querySelector(Nt)),
            (this.grandparent = this.classList.contains("grandparent")),
            (this.disclosure = document.getElementById(this.key)),
            (this.transitionTimeout = 0);
        }
      }
    );
  const Yt = "[data-drawer-inner]",
    Gt = "[data-drawer-close]",
    Jt = "[data-drawer-underlay]",
    Zt = "[data-stagger-animation]",
    te = 'button, [href], select, textarea, [tabindex]:not([tabindex="-1"])',
    ee = "drawer--animated",
    se = "is-open",
    ie = "is-closing",
    oe = "is-focused";
  customElements.get("header-drawer") ||
    customElements.define(
      "header-drawer",
      class extends HTMLElement {
        connectDrawer() {
          this.addEventListener("theme:drawer:toggle", (t) => {
            var e;
            (this.triggerButton = null === (e = t.detail) || void 0 === e ? void 0 : e.button),
              this.classList.contains(se)
                ? this.dispatchEvent(new CustomEvent("theme:drawer:close", { bubbles: !0 }))
                : this.dispatchEvent(new CustomEvent("theme:drawer:open", { bubbles: !0 }));
          }),
            this.addEventListener("theme:drawer:close", this.hideDrawer),
            this.addEventListener("theme:drawer:open", this.showDrawer),
            document.addEventListener("theme:cart-drawer:open", this.hideDrawer);
        }
        closers() {
          var t;
          null === (t = this.querySelectorAll(Gt)) ||
            void 0 === t ||
            t.forEach((t) => {
              t.addEventListener("click", () => {
                this.hideDrawer();
              });
            }),
            document.addEventListener("keyup", (t) => {
              "Escape" === t.code && this.hideDrawer();
            }),
            this.underlay.addEventListener("click", () => {
              this.hideDrawer();
            });
        }
        showDrawer() {
          var t;
          this.isAnimating ||
            ((this.isAnimating = !0),
            null === (t = this.triggerButton) || void 0 === t || t.setAttribute("aria-expanded", !0),
            this.classList.add(se, ee),
            document.dispatchEvent(new CustomEvent("theme:scroll:lock", { bubbles: !0 })),
            this.drawerInner &&
              (this.a11y.removeTrapFocus(),
              window.theme.waitForAnimationEnd(this.drawerInner).then(() => {
                (this.isAnimating = !1),
                  this.a11y.trapFocus(this.drawerInner, { elementToFocus: this.querySelector(te) });
              })));
        }
        hideDrawer() {
          !this.isAnimating &&
            this.classList.contains(se) &&
            ((this.isAnimating = !0),
            this.classList.add(ie),
            this.classList.remove(se),
            this.a11y.removeTrapFocus(),
            this.triggerButton &&
              (this.triggerButton.setAttribute("aria-expanded", !1),
              document.body.classList.contains(oe) && this.triggerButton.focus()),
            document.dispatchEvent(new CustomEvent("theme:scroll:unlock", { bubbles: !0 })),
            window.theme.waitForAnimationEnd(this.drawerInner).then(() => {
              this.classList.remove(ie, ee),
                (this.isAnimating = !1),
                document.dispatchEvent(new CustomEvent("theme:sliderule:close", { bubbles: !1 }));
            }));
        }
        disconnectedCallback() {
          document.removeEventListener("theme:cart-drawer:open", this.hideDrawer);
        }
        constructor() {
          super(),
            (this.a11y = window.theme.a11y),
            (this.isAnimating = !1),
            (this.drawer = this),
            (this.drawerInner = this.querySelector(Yt)),
            (this.underlay = this.querySelector(Jt)),
            (this.triggerButton = null),
            (this.staggers = this.querySelectorAll(Zt)),
            (this.showDrawer = this.showDrawer.bind(this)),
            (this.hideDrawer = this.hideDrawer.bind(this)),
            this.connectDrawer(),
            this.closers();
        }
      }
    );
  const ne = {
      animates: "data-animates",
      sliderule: "[data-sliderule]",
      slideruleOpen: "data-sliderule-open",
      slideruleClose: "data-sliderule-close",
      sliderulePane: "data-sliderule-pane",
      drawerContent: "[data-drawer-content]",
      focusable: 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])',
      children:
        ":scope > [data-animates],\n             :scope > * > [data-animates],\n             :scope > * > * > [data-animates],\n             :scope > * > .sliderule-grid  > *",
    },
    re = "is-visible",
    ae = "is-hiding",
    le = "is-hidden",
    de = "is-focused",
    ce = "is-scrolling";
  customElements.get("mobile-sliderule") ||
    customElements.define(
      "mobile-sliderule",
      class extends HTMLElement {
        clickEvents() {
          this.trigger.addEventListener("click", () => {
            (this.cachedButton = this.trigger), this.showSliderule();
          }),
            this.exit.forEach((t) => {
              t.addEventListener("click", () => {
                this.hideSliderule();
              });
            });
        }
        keyboardEvents() {
          this.addEventListener("keyup", (t) => {
            t.stopPropagation(), "Escape" === t.code && this.hideSliderule();
          });
        }
        trapFocusSliderule(t = !0) {
          const e = t ? this.querySelector(this.exitSelector) : this.cachedButton;
          this.a11y.removeTrapFocus(),
            e &&
              this.drawerContent &&
              this.a11y.trapFocus(this.drawerContent, {
                elementToFocus: document.body.classList.contains(de) ? e : null,
              });
        }
        hideSliderule(t = !1) {
          const e = parseInt(this.pane.dataset.sliderulePane, 10) - 1;
          this.pane.setAttribute(ne.sliderulePane, e), this.pane.classList.add(ae), this.sliderule.classList.add(ae);
          const s = t ? `[${ne.animates}].${le}` : `[${ne.animates}="${e}"]`,
            i = this.pane.querySelectorAll(s);
          i.length &&
            i.forEach((t) => {
              t.classList.remove(le);
            });
          const o = t ? this.pane.querySelectorAll(`.${re}, .${ae}`) : this.childrenElements;
          o.forEach((s, i) => {
            const n = o.length - 1 == i;
            s.classList.remove(re), t && (s.classList.remove(ae), this.pane.classList.remove(ae));
            const r = () => {
              parseInt(this.pane.getAttribute(ne.sliderulePane)) === e && this.sliderule.classList.remove(re),
                this.sliderule.classList.remove(ae),
                this.pane.classList.remove(ae),
                n && (this.a11y.removeTrapFocus(), t || this.trapFocusSliderule(!1)),
                s.removeEventListener("animationend", r);
            };
            window.theme.settings.enableAnimations ? s.addEventListener("animationend", r) : r();
          });
        }
        showSliderule() {
          let t = null;
          const e = this.closest(`.${re}`);
          let s = this.pane;
          e && (s = e), s.scrollTo({ top: 0, left: 0, behavior: "smooth" }), s.classList.add(ce);
          const i = () => {
            s.scrollTop <= 0 ? (s.classList.remove(ce), t && cancelAnimationFrame(t)) : (t = requestAnimationFrame(i));
          };
          t = requestAnimationFrame(i);
          const o = parseInt(this.pane.dataset.sliderulePane, 10),
            n = o + 1;
          this.sliderule.classList.add(re), this.pane.setAttribute(ne.sliderulePane, n);
          const r = this.pane.querySelectorAll(`[${ne.animates}="${o}"]`);
          r.length &&
            r.forEach((t, e) => {
              const s = r.length - 1 == e;
              t.classList.add(ae);
              const i = () => {
                t.classList.remove(ae),
                  parseInt(this.pane.getAttribute(ne.sliderulePane)) !== o && t.classList.add(le),
                  s && this.trapFocusSliderule(),
                  t.removeEventListener("animationend", i);
              };
              window.theme.settings.enableAnimations ? t.addEventListener("animationend", i) : i();
            });
        }
        closeSliderule() {
          this.pane &&
            this.pane.hasAttribute(ne.sliderulePane) &&
            parseInt(this.pane.getAttribute(ne.sliderulePane)) > 0 &&
            (this.hideSliderule(!0),
            parseInt(this.pane.getAttribute(ne.sliderulePane)) > 0 && this.pane.setAttribute(ne.sliderulePane, 0));
        }
        disconnectedCallback() {
          document.removeEventListener("theme:sliderule:close", this.closeSliderule);
        }
        constructor() {
          super(), (this.key = this.id), (this.sliderule = this.querySelector(ne.sliderule));
          const t = `[${ne.slideruleOpen}='${this.key}']`;
          (this.exitSelector = `[${ne.slideruleClose}='${this.key}']`),
            (this.trigger = this.querySelector(t)),
            (this.exit = document.querySelectorAll(this.exitSelector)),
            (this.pane = this.trigger.closest(`[${ne.sliderulePane}]`)),
            (this.childrenElements = this.querySelectorAll(ne.children)),
            (this.drawerContent = this.closest(ne.drawerContent)),
            (this.cachedButton = null),
            (this.a11y = window.theme.a11y),
            this.trigger.setAttribute("aria-haspopup", !0),
            this.trigger.setAttribute("aria-expanded", !1),
            this.trigger.setAttribute("aria-controls", this.key),
            (this.closeSliderule = this.closeSliderule.bind(this)),
            this.clickEvents(),
            this.keyboardEvents(),
            document.addEventListener("theme:sliderule:close", this.closeSliderule);
        }
      }
    );
  const he = "details",
    ue = "[data-popdown]",
    me = "[data-popdown-close]",
    pe = "mobile-menu",
    ve = "data-popdown-underlay",
    ge = "data-scroll-locked",
    be = "is-open";
  let we = class extends HTMLElement {
    connectedCallback() {
      this.popdown.addEventListener("transitionend", this.popdownTransitionCallback),
        this.popdownContainer.addEventListener("keyup", (t) => "ESCAPE" === t.code.toUpperCase() && this.close()),
        this.popdownContainer.addEventListener("toggle", this.detailsToggleCallback),
        this.popdownClose.addEventListener("click", this.close.bind(this));
    }
    detailsToggleCallback(t) {
      t.target.hasAttribute("open") && this.open();
    }
    popdownTransitionCallback(t) {
      t.target === this.popdown &&
        "opacity" === t.propertyName &&
        (this.classList.contains("is-open")
          ? this.a11y.trapFocus(this.popdown, {
              elementToFocus: this.popdown.querySelector('input:not([type="hidden"])'),
            })
          : (this.popdownContainer.removeAttribute("open"), this.a11y.removeTrapFocus()));
    }
    onBodyClick(t) {
      (this.contains(t.target) && !t.target.hasAttribute(ve)) || this.close();
    }
    open() {
      (this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this)),
        document.body.addEventListener("click", this.onBodyClickEvent),
        document.documentElement.hasAttribute(ge) ||
          document.dispatchEvent(new CustomEvent("theme:scroll:lock", { bubbles: !0 })),
        requestAnimationFrame(() => {
          this.classList.add(be);
        });
    }
    close() {
      this.classList.remove(be),
        document.body.removeEventListener("click", this.onBodyClickEvent),
        this.mobileMenu || document.dispatchEvent(new CustomEvent("theme:scroll:unlock", { bubbles: !0 }));
    }
    constructor() {
      super(),
        (this.popdown = this.querySelector(ue)),
        (this.popdownContainer = this.querySelector(he)),
        (this.popdownClose = this.querySelector(me)),
        (this.popdownTransitionCallback = this.popdownTransitionCallback.bind(this)),
        (this.detailsToggleCallback = this.detailsToggleCallback.bind(this)),
        (this.mobileMenu = this.closest(pe)),
        (this.a11y = window.theme.a11y);
    }
  };
  customElements.get("header-search-popdown") || customElements.define("header-search-popdown", we);
  const ye = 'input[type="search"]',
    Ee = '[aria-selected="true"] a',
    fe = 'button[type="reset"]',
    Le = "hidden";
  let Se = class extends HTMLElement {
    toggleResetButton() {
      const t = this.resetButton.classList.contains(Le);
      this.input.value.length > 0 && t
        ? this.resetButton.classList.remove(Le)
        : 0 !== this.input.value.length || t || this.resetButton.classList.add(Le);
    }
    onChange() {
      this.toggleResetButton();
    }
    shouldResetForm() {
      return !document.querySelector(Ee);
    }
    onFormReset(t) {
      t.preventDefault(),
        this.shouldResetForm() &&
          ((this.input.value = ""), this.toggleResetButton(), t.target.querySelector(ye).focus());
    }
    constructor() {
      super(),
        (this.input = this.querySelector(ye)),
        (this.resetButton = this.querySelector(fe)),
        this.input &&
          (this.input.form.addEventListener("reset", this.onFormReset.bind(this)),
          this.input.addEventListener(
            "input",
            window.theme
              .debounce((t) => {
                this.onChange(t);
              }, 300)
              .bind(this)
          ));
    }
  };
  customElements.define("header-search-form", Se);
  const Ae = 'input[type="search"]';
  let ke = class extends Se {
    setupEventListeners() {
      let t = [];
      this.allSearchInputs.forEach((e) => t.push(e.form)),
        this.input.addEventListener("focus", this.onInputFocus.bind(this)),
        t.length < 2 ||
          (t.forEach((t) => t.addEventListener("reset", this.onFormReset.bind(this))),
          this.allSearchInputs.forEach((t) => t.addEventListener("input", this.onInput.bind(this))));
    }
    onFormReset(t) {
      super.onFormReset(t), super.shouldResetForm() && this.keepInSync("", this.input);
    }
    onInput(t) {
      const e = t.target;
      this.keepInSync(e.value, e);
    }
    onInputFocus() {
      window.theme.isMobile() && this.scrollIntoView({ behavior: "smooth" });
    }
    keepInSync(t, e) {
      this.allSearchInputs.forEach((s) => {
        s !== e && (s.value = t);
      });
    }
    constructor() {
      super(), (this.allSearchInputs = document.querySelectorAll(Ae)), this.setupEventListeners();
    }
  };
  customElements.get("main-search") || customElements.define("main-search", ke);
  const Ce = "[data-scrollbar]",
    qe = "[data-scrollbar-arrow-prev]",
    Te = "[data-scrollbar-arrow-next]",
    Me = "is-hidden",
    xe = "data-scrollbar-slider",
    He = "data-scrollbar-slide-fullwidth";
  customElements.get("native-scrollbar") ||
    customElements.define(
      "native-scrollbar",
      class extends HTMLElement {
        connectedCallback() {
          document.addEventListener("theme:resize", this.toggleNextArrow),
            this.scrollbar.hasAttribute(xe) && this.scrollToVisibleElement(),
            this.arrowNext && this.arrowPrev && (this.events(), this.toggleNextArrow());
        }
        disconnectedCallback() {
          document.removeEventListener("theme:resize", this.toggleNextArrow);
        }
        events() {
          this.arrowNext.addEventListener("click", (t) => {
            t.preventDefault(), this.goToNext();
          }),
            this.arrowPrev.addEventListener("click", (t) => {
              t.preventDefault(), this.goToPrev();
            }),
            this.scrollbar.addEventListener("scroll", () => {
              this.togglePrevArrow(), this.toggleNextArrow();
            });
        }
        goToNext() {
          const t =
            (this.scrollbar.hasAttribute(He)
              ? this.scrollbar.getBoundingClientRect().width
              : this.scrollbar.getBoundingClientRect().width / 2) + this.scrollbar.scrollLeft;
          this.move(t), this.arrowPrev.classList.remove(Me), this.toggleNextArrow();
        }
        goToPrev() {
          const t = this.scrollbar.hasAttribute(He)
              ? this.scrollbar.getBoundingClientRect().width
              : this.scrollbar.getBoundingClientRect().width / 2,
            e = this.scrollbar.scrollLeft - t;
          this.move(e), this.arrowNext.classList.remove(Me), this.togglePrevArrow();
        }
        toggleNextArrow() {
          requestAnimationFrame(() => {
            var t;
            null === (t = this.arrowNext) ||
              void 0 === t ||
              t.classList.toggle(
                Me,
                Math.round(this.scrollbar.scrollLeft + this.scrollbar.getBoundingClientRect().width + 1) >=
                  this.scrollbar.scrollWidth
              );
          });
        }
        togglePrevArrow() {
          requestAnimationFrame(() => {
            this.arrowPrev.classList.toggle(Me, this.scrollbar.scrollLeft <= 0);
          });
        }
        scrollToVisibleElement() {
          [].forEach.call(this.scrollbar.children, (t) => {
            t.addEventListener("click", (e) => {
              e.preventDefault(), this.move(t.offsetLeft - t.clientWidth);
            });
          });
        }
        move(t, e = "smooth") {
          this.scrollbar.scrollTo({ top: 0, left: t, behavior: e });
        }
        constructor() {
          super(),
            (this.scrollbar = this.querySelector(Ce)),
            (this.arrowNext = this.querySelector(Te)),
            (this.arrowPrev = this.querySelector(qe)),
            (this.toggleNextArrow = this.toggleNextArrow.bind(this)),
            this.addEventListener("theme:swatches:loaded", this.toggleNextArrow);
        }
      }
    ),
    customElements.get("popout-select") ||
      customElements.define(
        "popout-select",
        class extends HTMLElement {
          connectedCallback() {
            (this.popoutList = this.querySelector("[data-popout-list]")),
              (this.popoutToggle = this.querySelector("[data-popout-toggle]")),
              (this.popoutToggleText = this.querySelector("[data-popout-toggle-text]")),
              (this.popoutInput =
                this.querySelector("[data-popout-input]") ||
                this.parentNode.querySelector("[data-popout-input]") ||
                this.parentNode.parentNode.querySelector("[data-quantity-input]")),
              (this.popoutOptions = this.querySelectorAll("[data-popout-option]")),
              (this.productGridItem = this.popoutList.closest("[data-grid-item]")),
              (this.fireSubmitEvent = this.hasAttribute("submit")),
              (this.popupToggleFocusoutEvent = (t) => this.onPopupToggleFocusout(t)),
              (this.popupListFocusoutEvent = (t) => this.onPopupListFocusout(t)),
              (this.popupToggleClickEvent = (t) => this.onPopupToggleClick(t)),
              (this.keyUpEvent = (t) => this.onKeyUp(t)),
              (this.bodyClickEvent = (t) => this.onBodyClick(t)),
              this._connectOptions(),
              this._connectToggle(),
              this._onFocusOut(),
              this.popupListSetDimensions();
          }
          onPopupToggleClick(t) {
            const e = "true" === t.currentTarget.getAttribute("aria-expanded");
            if (this.productGridItem) {
              const t = this.productGridItem.querySelector("[data-product-image]");
              t && t.classList.toggle("is-visible", !e),
                (this.popoutList.style.maxHeight = `${Math.abs(
                  this.popoutToggle.getBoundingClientRect().bottom - this.productGridItem.getBoundingClientRect().bottom
                )}px`);
            }
            t.currentTarget.setAttribute("aria-expanded", !e),
              this.popoutList.classList.toggle("popout-list--visible"),
              this.popupListSetDimensions(),
              this.toggleListPosition(),
              document.body.addEventListener("click", this.bodyClickEvent);
          }
          onPopupToggleFocusout(t) {
            this.contains(t.relatedTarget) || this._hideList();
          }
          onPopupListFocusout(t) {
            const e = t.currentTarget.contains(t.relatedTarget);
            this.popoutList.classList.contains("popout-list--visible") && !e && this._hideList();
          }
          toggleListPosition() {
            const t = this.querySelector("[data-popout-toggle]"),
              e = this.getBoundingClientRect().top + this.clientHeight,
              s = () => {
                "true" !== t.getAttribute("aria-expanded") && this.popoutList.classList.remove("popout-list--top"),
                  this.popoutList.removeEventListener("transitionend", s);
              };
            "true" === t.getAttribute("aria-expanded")
              ? window.innerHeight / 2 < e && this.popoutList.classList.add("popout-list--top")
              : this.popoutList.addEventListener("transitionend", s);
          }
          popupListSetDimensions() {
            this.popoutList.style.setProperty("--max-width", "100vw"),
              this.popoutList.style.setProperty("--max-height", "100vh"),
              requestAnimationFrame(() => {
                this.popoutList.style.setProperty(
                  "--max-width",
                  `${parseInt(document.body.clientWidth - this.popoutList.getBoundingClientRect().left)}px`
                ),
                  this.popoutList.style.setProperty(
                    "--max-height",
                    `${parseInt(document.body.clientHeight - this.popoutList.getBoundingClientRect().top)}px`
                  );
              });
          }
          popupOptionsClick(t) {
            if ("#" === t.target.closest("[data-popout-option]").attributes.href.value) {
              t.preventDefault();
              const e = t.currentTarget.hasAttribute("data-value") ? t.currentTarget.getAttribute("data-value") : "";
              this.popoutInput.value = e;
              const s = t.currentTarget.closest("li");
              if (s) {
                const t = s.getAttribute("data-option-value-id"),
                  e = s.getAttribute("data-product-url");
                t && this.popoutInput.setAttribute("data-option-value-id", t),
                  e && this.popoutInput.setAttribute("data-product-url", e);
              }
              if ((this.popoutInput.disabled && this.popoutInput.removeAttribute("disabled"), this.fireSubmitEvent))
                this._submitForm(e);
              else {
                const s = t.currentTarget.parentElement,
                  i = this.popoutList.querySelector(".is-active"),
                  o = this.popoutList.querySelector("[aria-current]");
                this.popoutInput.dispatchEvent(new Event("change", { bubbles: !0 })),
                  i && (i.classList.remove("is-active"), s.classList.add("is-active")),
                  "quantity" != this.popoutInput.name || s.nextSibling || this.classList.add("is-active"),
                  o &&
                    o.hasAttribute("aria-current") &&
                    (o.removeAttribute("aria-current"), t.currentTarget.setAttribute("aria-current", "true")),
                  "" !== e &&
                    ((this.popoutToggleText.innerHTML = e),
                    this.popoutToggleText.hasAttribute("data-popout-toggle-text") &&
                      "" !== this.popoutToggleText.getAttribute("data-popout-toggle-text") &&
                      this.popoutToggleText.setAttribute("data-popout-toggle-text", e)),
                  this.onPopupToggleFocusout(t),
                  this.onPopupListFocusout(t);
              }
            }
          }
          onKeyUp(t) {
            "Escape" === t.code && (this._hideList(), this.popoutToggle.focus());
          }
          onBodyClick(t) {
            const e = this.contains(t.target);
            this.popoutList.classList.contains("popout-list--visible") && !e && this._hideList();
          }
          _connectToggle() {
            this.popoutToggle.addEventListener("click", this.popupToggleClickEvent);
          }
          _connectOptions() {
            this.popoutOptions.length &&
              this.popoutOptions.forEach((t) => {
                t.addEventListener("click", (t) => this.popupOptionsClick(t));
              });
          }
          _onFocusOut() {
            this.addEventListener("keyup", this.keyUpEvent),
              this.popoutToggle.addEventListener("focusout", this.popupToggleFocusoutEvent),
              this.popoutList.addEventListener("focusout", this.popupListFocusoutEvent);
          }
          _submitForm() {
            const t = this.closest("form");
            t && t.submit();
          }
          _hideList() {
            this.popoutList.classList.remove("popout-list--visible"),
              this.popoutToggle.setAttribute("aria-expanded", !1),
              this.toggleListPosition(),
              document.body.removeEventListener("click", this.bodyClickEvent);
          }
          constructor() {
            super();
          }
        }
      );
  const Ie = {
      open: "[data-popup-open]",
      close: "[data-popup-close]",
      dialog: "dialog",
      focusable: 'button, [href], select, textarea, [tabindex]:not([tabindex="-1"])',
      newsletterForm: "[data-newsletter-form]",
      newsletterHeading: "[data-newsletter-heading]",
      newsletterField: "[data-newsletter-field]",
    },
    Pe = {
      closing: "closing",
      delay: "data-popup-delay",
      scrollLock: "data-scroll-lock-required",
      cookieName: "data-cookie-name",
      cookieValue: "data-cookie-value",
      preventTopLayer: "data-prevent-top-layer",
    },
    De = "hidden",
    Oe = "has-value",
    Fe = "cart-bar-visible",
    Be = "is-visible",
    $e = "has-success",
    _e = "mobile",
    Re = "desktop",
    We = "bottom";
  let Ne = class extends HTMLElement {
      checkTargetReferrer() {
        this.popup.hasAttribute(Pe.referrer) &&
          (-1 !== location.href.indexOf(this.popup.getAttribute(Pe.referrer)) ||
            window.Shopify.designMode ||
            this.popup.parentNode.removeChild(this.popup));
      }
      checkCookie() {
        (this.cookie && !1 !== this.cookie.read()) ||
          (this.showPopupEvents(), this.popup.addEventListener("theme:popup:onclose", () => this.cookie.write()));
      }
      bindListeners() {
        var t, e;
        null === (t = this.buttonPopupOpen) ||
          void 0 === t ||
          t.addEventListener("click", (t) => {
            t.preventDefault(), this.popupOpen(), (window.theme.a11y.lastElement = this.buttonPopupOpen);
          }),
          null === (e = this.popup.querySelectorAll(Ie.close)) ||
            void 0 === e ||
            e.forEach((t) => {
              t.addEventListener("click", (t) => {
                t.preventDefault(), this.popupClose();
              });
            }),
          this.popup.addEventListener("click", (t) => {
            "DIALOG" === t.target.nodeName && "click" === t.type && this.popupClose();
          }),
          this.popup.addEventListener("keydown", (t) => {
            "Escape" === t.code && (t.preventDefault(), this.popupClose());
          }),
          this.popup.addEventListener("close", () => this.popupCloseActions());
      }
      popupOpen() {
        console.log("Popup open called");
        console.log("this", this);
        console.log("this.isAnimating", this.isAnimating);
        console.log("this.popup", this.popup);
        (this.isAnimating = !0),
          "function" != typeof this.popup.showModal || this.preventTopLayer
            ? "function" == typeof this.popup.show
              ? this.popup.show()
              : this.popup.setAttribute("open", "")
            : this.popup.showModal(),
          this.popup.removeAttribute("inert"),
          this.popup.setAttribute("aria-hidden", !1),
          this.popup.focus(),
          this.enableScrollLock && document.dispatchEvent(new CustomEvent("theme:scroll:lock", { bubbles: !0 })),
          window.theme.waitForAnimationEnd(this.popup).then(() => {
            (this.isAnimating = !1), this.enableScrollLock && this.a11y.trapFocus(this.popup);
            const t = this.popup.querySelector("[autofocus]") || this.popup.querySelector(Ie.focusable);
            null == t || t.focus();
          });
      }
      popupClose() {
        console.log("Popup close called");
        if (!this.isAnimating && !this.popup.hasAttribute("inert")) {
          if (!this.popup.hasAttribute(Pe.closing))
            return (
              this.popup.setAttribute(Pe.closing, ""),
              (this.isAnimating = !0),
              void window.theme.waitForAnimationEnd(this.popup).then(() => {
                (this.isAnimating = !1), this.popupClose();
              })
            );
          "function" == typeof this.popup.close
            ? this.popup.close()
            : (this.popup.removeAttribute("open"), this.popup.setAttribute("aria-hidden", !0)),
            this.popupCloseActions();
        }
      }
      popupCloseActions() {
        this.popup.hasAttribute("inert") ||
          (this.popup.setAttribute("inert", ""),
          this.popup.setAttribute("aria-hidden", !0),
          this.popup.removeAttribute(Pe.closing),
          !window.theme.hasOpenModals() &&
            this.enableScrollLock &&
            document.dispatchEvent(new CustomEvent("theme:scroll:unlock", { bubbles: !0 })),
          this.popup.dispatchEvent(new CustomEvent("theme:popup:onclose", { bubbles: !1 })),
          this.enableScrollLock && (this.a11y.removeTrapFocus(), this.a11y.autoFocusLastElement()));
      }
      showPopupEvents() {
        this.popup.hasAttribute("open") && 1 == this.popup.getAttribute("open") && this.popupOpen(),
          (this.delay = this.popup.hasAttribute(Pe.delay) ? this.popup.getAttribute(Pe.delay) : null),
          (this.isSubmitted =
            -1 !== window.location.href.indexOf("accepts_marketing") ||
            -1 !== window.location.href.indexOf("customer_posted=true")),
          (this.showOnScrollEvent = window.theme.throttle(this.showOnScroll.bind(this), 200)),
          ("always" === this.delay || this.isSubmitted) && this.popupOpen(),
          this.delay && this.delay.includes("delayed") && !this.isSubmitted && this.showDelayed(),
          "bottom" !== this.delay || this.isSubmitted || this.showOnBottomReached(),
          "idle" !== this.delay || this.isSubmitted || this.showOnIdle();
      }
      showDelayed() {
        const t = this.delay.includes("_") ? parseInt(this.delay.split("_")[1]) : 10;
        setTimeout(() => {
          this.popupOpen();
        }, 1e3 * t);
      }
      showOnIdle() {
        let t = 0;
        const e = ["mousemove", "mousedown", "click", "touchmove", "touchstart", "touchend", "keydown", "keypress"],
          s = ["load", "resize", "scroll"],
          i = () => {
            (t = setTimeout(() => {
              (t = 0), this.popupOpen();
            }, 6e4)),
              e.forEach((t) => {
                document.addEventListener(t, o);
              }),
              s.forEach((t) => {
                window.addEventListener(t, o);
              });
          },
          o = () => {
            t && clearTimeout(t),
              e.forEach((t) => {
                document.removeEventListener(t, o);
              }),
              s.forEach((t) => {
                window.removeEventListener(t, o);
              }),
              i();
          };
        i();
      }
      showOnBottomReached() {
        document.addEventListener("theme:scroll", this.showOnScrollEvent);
      }
      showOnScroll() {
        window.scrollY + window.innerHeight >= document.body.clientHeight &&
          (this.popupOpen(), document.removeEventListener("theme:scroll", this.showOnScrollEvent));
      }
      disconnectedCallback() {
        document.removeEventListener("theme:scroll", this.showOnScrollEvent);
      }
      constructor() {
        super(),
          (this.popup = this.querySelector(Ie.dialog)),
          (this.preventTopLayer = this.popup.hasAttribute(Pe.preventTopLayer)),
          (this.enableScrollLock = this.popup.hasAttribute(Pe.scrollLock)),
          (this.buttonPopupOpen = this.querySelector(Ie.open)),
          (this.a11y = window.theme.a11y),
          (this.isAnimating = !1),
          (this.cookie = new (class {
            write() {
              ((-1 !== document.cookie.indexOf("; ") &&
                !document.cookie.split("; ").find((t) => t.startsWith(this.name))) ||
                -1 === document.cookie.indexOf("; ")) &&
                (document.cookie = `${this.name}=${this.value}; expires=${this.config.expires}; path=${this.config.path}; domain=${this.config.domain}; sameSite=${this.config.sameSite}; secure=${this.config.secure}`);
            }
            read() {
              return (
                !(
                  -1 === document.cookie.indexOf("; ") ||
                  !document.cookie.split("; ").find((t) => t.startsWith(this.name))
                ) &&
                document.cookie
                  .split("; ")
                  .find((t) => t.startsWith(this.name))
                  .split("=")[1]
              );
            }
            destroy() {
              document.cookie.split("; ").find((t) => t.startsWith(this.name)) &&
                (document.cookie = `${this.name}=null; expires=${this.config.expires}; path=${this.config.path}; domain=${this.config.domain}`);
            }
            constructor(t, e, s = 7) {
              const i = new Date(),
                o = new Date();
              o.setTime(i.getTime() + 864e5 * s),
                (this.config = {
                  expires: o.toGMTString(),
                  path: "/",
                  domain: window.location.hostname,
                  sameSite: "none",
                  secure: !0,
                }),
                (this.name = t),
                (this.value = e);
            }
          })(this.popup.getAttribute(Pe.cookieName), this.popup.getAttribute(Pe.cookieValue))),
          this.checkTargetReferrer(),
          this.checkCookie(),
          this.bindListeners();
      }
    },
    Ue = class extends Ne {
      connectedCallback() {
        var t;
        const e = !1 !== (null === (t = this.cookie) || void 0 === t ? void 0 : t.read()),
          s = -1 !== window.location.search.indexOf("?customer_posted=true"),
          i = [...this.classList].toString().includes(We),
          o = this.popup.classList.contains(_e),
          n = this.popup.classList.contains(Re),
          r = window.theme.isMobile();
        let a = !0;
        if ((((o && !r) || (n && r)) && (a = !1), !a))
          return (
            super.a11y.removeTrapFocus(),
            void document.dispatchEvent(new CustomEvent("theme:scroll:unlock", { bubbles: !0 }))
          );
        (e && !window.Shopify.designMode) ||
          (window.Shopify.designMode || window.location.pathname.endsWith("/challenge") || super.showPopupEvents(),
          this.form && this.form.classList.contains($e) && (super.popupOpen(), this.cookie.write()),
          this.popup.addEventListener("theme:popup:onclose", () => this.cookie.write())),
          s && (this.delay = 0),
          (e && !window.Shopify.designMode) ||
            (this.show(), this.form.classList.contains($e) && (this.popupOpen(), this.cookie.write())),
          i && this.observeCartBar();
      }
      show() {
        window.location.pathname.endsWith("/challenge") ||
          (window.Shopify.designMode ? super.popupOpen() : super.showPopupEvents()),
          this.showForm(),
          this.inputField(),
          this.popup.addEventListener("theme:popup:onclose", () => this.cookie.write());
      }
      observeCartBar() {
        if (((this.cartBar = document.getElementById(Ie.cartBar)), !this.cartBar)) return;
        let t = this.cartBar.classList.contains(Be);
        document.body.classList.toggle(Fe, t);
        (this.observer = new MutationObserver((e) => {
          for (const s of e)
            "attributes" === s.type && ((t = s.target.classList.contains(Be)), document.body.classList.toggle(Fe, t));
        })),
          this.observer.observe(this.cartBar, { attributes: !0, childList: !1, subtree: !1 });
      }
      showForm() {
        var t, e;
        null === (t = this.heading) ||
          void 0 === t ||
          t.addEventListener("click", (t) => {
            t.preventDefault(),
              this.heading.classList.add(De),
              this.form.classList.remove(De),
              this.newsletterField.focus();
          }),
          null === (e = this.heading) ||
            void 0 === e ||
            e.addEventListener("keyup", (t) => {
              "Enter" === t.code && this.heading.dispatchEvent(new Event("click"));
            });
      }
      inputField() {
        const t = () => {
          this.resetClassTimer && clearTimeout(this.resetClassTimer),
            "" !== this.newsletterField.value && this.popup.classList.add(Oe);
        };
        this.newsletterField.addEventListener("input", t),
          this.newsletterField.addEventListener("focus", t),
          this.newsletterField.addEventListener("focusout", () => {
            this.resetClassTimer && clearTimeout(this.resetClassTimer),
              (this.resetClassTimer = setTimeout(() => {
                this.popup.classList.remove(Oe);
              }, 2e3));
          });
      }
      disconnectedCallback() {
        this.observer && this.observer.disconnect();
      }
      constructor() {
        super(),
          (this.form = this.popup.querySelector(Ie.newsletterForm)),
          (this.heading = this.popup.querySelector(Ie.newsletterHeading)),
          (this.newsletterField = this.popup.querySelector(Ie.newsletterField));
      }
    };
  customElements.get("popup-component") || customElements.define("popup-component", Ne),
    customElements.get("popup-newsletter") || customElements.define("popup-newsletter", Ue);
  const Ve = '[role="option"]',
    ze = '[aria-selected="true"]',
    je = "[data-popular-searches]",
    Xe = "predictive-search",
    Ke = "[data-predictive-search-results]",
    Qe = "[data-predictive-search-status]",
    Ye = 'input[type="search"]',
    Ge = "[data-popdown]",
    Je = "[data-predictive-search-live-region-count-value]",
    Ze = "[data-search-results-groups-wrapper]",
    ts = "[data-predictive-search-search-for-text]",
    es = "#shopify-section-predictive-search",
    ss = '[aria-selected="true"] a',
    is = '[aria-selected="true"] a, button[aria-selected="true"]';
  customElements.get("predictive-search") ||
    customElements.define(
      "predictive-search",
      class extends Se {
        connectedCallback() {
          this.input.addEventListener("focus", this.onFocus.bind(this)),
            this.input.form.addEventListener("submit", this.onFormSubmit.bind(this)),
            this.addEventListener("focusout", this.onFocusOut.bind(this)),
            this.addEventListener("keyup", this.onKeyup.bind(this)),
            this.addEventListener("keydown", this.onKeydown.bind(this));
        }
        getQuery() {
          return this.input.value.trim();
        }
        onChange() {
          super.onChange();
          const t = this.getQuery();
          var e;
          (this.searchTerm && t.startsWith(this.searchTerm)) ||
            null === (e = this.querySelector(Ze)) ||
            void 0 === e ||
            e.remove();
          this.updateSearchForTerm(this.searchTerm, t),
            (this.searchTerm = t),
            this.searchTerm.length ? this.getSearchResults(this.searchTerm) : this.reset();
        }
        onFormSubmit(t) {
          (this.getQuery().length && !this.querySelector(ss)) || t.preventDefault();
        }
        onFormReset(t) {
          super.onFormReset(t),
            super.shouldResetForm() &&
              ((this.searchTerm = ""),
              this.abortController.abort(),
              (this.abortController = new AbortController()),
              this.closeResults(!0));
        }
        shouldResetForm() {
          return !document.querySelector(ss);
        }
        onFocus() {
          const t = this.getQuery();
          t.length &&
            (this.searchTerm !== t
              ? this.onChange()
              : "true" === this.getAttribute("results")
              ? this.open()
              : this.getSearchResults(this.searchTerm));
        }
        onFocusOut() {
          setTimeout(() => {
            this.contains(document.activeElement) || this.close();
          });
        }
        onKeyup(t) {
          switch ((this.getQuery().length || this.close(!0), t.preventDefault(), t.code)) {
            case "ArrowUp":
              this.switchOption("up");
              break;
            case "ArrowDown":
              this.switchOption("down");
              break;
            case "Enter":
              this.selectOption();
          }
        }
        onKeydown(t) {
          ("ArrowUp" !== t.code && "ArrowDown" !== t.code) || t.preventDefault();
        }
        updateSearchForTerm(t, e) {
          const s = this.querySelector(ts),
            i = null == s ? void 0 : s.innerText;
          if (i) {
            var o;
            if ((null === (o = i.match(new RegExp(t, "g"))) || void 0 === o ? void 0 : o.length) > 1) return;
            const n = i.replace(t, e);
            s.innerText = n;
          }
        }
        switchOption(t) {
          if (!this.getAttribute("open")) return;
          const e = "up" === t,
            s = this.querySelector(ze),
            i = Array.from(this.querySelectorAll(Ve)).filter((t) => null !== t.offsetParent);
          let o = 0;
          if (e && !s) return;
          let n = -1,
            r = 0;
          for (; -1 === n && r <= i.length; ) i[r] === s && (n = r), r++;
          if (
            ((this.statusElement.textContent = ""),
            !e && s ? (o = n === i.length - 1 ? 0 : n + 1) : e && (o = 0 === n ? i.length - 1 : n - 1),
            o === n)
          )
            return;
          const a = i[o];
          a.setAttribute("aria-selected", !0),
            s && s.setAttribute("aria-selected", !1),
            this.input.setAttribute("aria-activedescendant", a.id);
        }
        selectOption() {
          const t = this.querySelector(is);
          t && t.click();
        }
        getSearchResults(t) {
          const e = t.replace(" ", "-").toLowerCase();
          this.setLiveRegionLoadingState(),
            this.cachedResults[e]
              ? this.renderSearchResults(this.cachedResults[e])
              : fetch(`${theme.routes.predictive_search_url}?q=${encodeURIComponent(t)}&section_id=predictive-search`, {
                  signal: this.abortController.signal,
                })
                  .then((t) => {
                    if (!t.ok) {
                      var e = new Error(t.status);
                      throw (this.close(), e);
                    }
                    return t.text();
                  })
                  .then((t) => {
                    const s = new DOMParser().parseFromString(t, "text/html").querySelector(es).innerHTML;
                    this.allPredictiveSearchInstances.forEach((t) => {
                      t.cachedResults[e] = s;
                    }),
                      this.renderSearchResults(s);
                  })
                  .catch((t) => {
                    if (20 !== (null == t ? void 0 : t.code)) throw (this.close(), t);
                  });
        }
        setLiveRegionLoadingState() {
          (this.statusElement = this.statusElement || this.querySelector(Qe)),
            (this.loadingText = this.loadingText || this.getAttribute("data-loading-text")),
            this.setLiveRegionText(this.loadingText),
            this.setAttribute("loading", !0);
        }
        setLiveRegionText(t) {
          this.statusElement.setAttribute("aria-hidden", "false"),
            (this.statusElement.textContent = t),
            setTimeout(() => {
              this.statusElement.setAttribute("aria-hidden", "true");
            }, 1e3);
        }
        renderSearchResults(t) {
          (this.predictiveSearchResults.innerHTML = t),
            this.setAttribute("results", !0),
            this.setLiveRegionResults(),
            this.open();
        }
        setLiveRegionResults() {
          this.removeAttribute("loading"), this.setLiveRegionText(this.querySelector(Je).textContent);
        }
        open() {
          this.setAttribute("open", !0),
            this.input.setAttribute("aria-expanded", !0),
            (this.isOpen = !0),
            this.predictiveSearchResults.style.setProperty(
              "--results-height",
              window.visualViewport.height - this.predictiveSearchResults.getBoundingClientRect().top + "px"
            );
        }
        close(t = !1) {
          this.closeResults(t),
            (this.isOpen = !1),
            this.predictiveSearchResults.style.removeProperty("--results-height");
        }
        closeResults(t = !1) {
          var e;
          t && ((this.input.value = ""), this.removeAttribute("results"));
          const s = this.querySelector(ze);
          s && s.setAttribute("aria-selected", !1),
            this.input.setAttribute("aria-activedescendant", ""),
            this.removeAttribute("loading"),
            this.removeAttribute("open"),
            this.input.setAttribute("aria-expanded", !1),
            null === (e = this.predictiveSearchResults) || void 0 === e || e.removeAttribute("style");
        }
        reset() {
          (this.predictiveSearchResults.innerHTML = ""),
            (this.input.val = ""),
            this.a11y.removeTrapFocus(),
            this.popularSearches &&
              (this.input.dispatchEvent(new Event("blur", { bubbles: !1 })),
              this.a11y.trapFocus(this.searchPopdown, { elementToFocus: this.input }));
        }
        constructor() {
          var t;
          super(),
            (this.a11y = window.theme.a11y),
            (this.abortController = new AbortController()),
            (this.allPredictiveSearchInstances = document.querySelectorAll(Xe)),
            (this.cachedResults = {}),
            (this.input = this.querySelector(Ye)),
            (this.isOpen = !1),
            (this.predictiveSearchResults = this.querySelector(Ke)),
            (this.searchPopdown = this.closest(Ge)),
            (this.popularSearches = null === (t = this.searchPopdown) || void 0 === t ? void 0 : t.querySelector(je)),
            (this.searchTerm = "");
        }
      }
    ),
    customElements.get("product-form") ||
      customElements.define(
        "product-form",
        class extends HTMLElement {
          onSubmitHandler(t) {
            t.preventDefault(),
              document.dispatchEvent(
                new CustomEvent("theme:cart:add", { detail: { button: this.submitButton }, bubbles: !1 })
              );
            this.closest("quick-add-modal") || (window.a11y.lastElement = this.submitButton);
          }
          toggleSubmitButton(t = !0, e = window.theme.strings.addToCart) {
            this.submitButton.toggleAttribute("disabled", t);
            const s = this.submitButtonText.querySelector("[data-product-price]");
            if (s) {
              const t = s.outerHTML;
              (this.submitButtonText.textContent = e), this.submitButtonText.insertAdjacentHTML("beforeend", ` ${t}`);
            } else this.submitButtonText.textContent = e;
          }
          get variantIdInput() {
            return this.form.querySelector("[name=id]");
          }
          constructor() {
            super(),
              (this.form = this.querySelector("form")),
              (this.variantIdInput.disabled = !1),
              this.form.addEventListener("submit", this.onSubmitHandler.bind(this)),
              (this.cart = document.querySelector("cart-drawer")),
              (this.submitButton = this.querySelector('[type="submit"]')),
              (this.submitButtonText = this.submitButton.querySelector("[data-add-to-cart-text]")),
              document.querySelector("cart-drawer") && this.submitButton.setAttribute("aria-haspopup", "dialog"),
              (this.hideErrors = "true" === this.dataset.hideErrors);
          }
        }
      );
  const os = "[data-grid-swatch-fieldset]",
    ns = "[data-grid-item]",
    rs = "[data-product-information]",
    as = "[data-product-image]",
    ls = "[data-swatch-button]",
    ds = "is-visible",
    cs = "no-events",
    hs = "data-swatch-handle",
    us = "data-swatch-label",
    ms = "data-swatch-count",
    ps = "data-swatch-variant-name",
    vs = "data-variant-title";
  let gs = class extends HTMLElement {
    connectedCallback() {
      (this.handle = this.getAttribute(hs)),
        (this.productItem = this.closest(ns)),
        (this.productInfo = this.closest(rs)),
        (this.productImage = this.productItem.querySelector(as)),
        (this.swatchesStyle = theme.settings.collectionSwatchStyle),
        document.addEventListener("theme:resize:width", this.resizeEvent);
      const t = this.getAttribute(us).trim().toLowerCase();
      (function (t) {
        const e = `${window.theme.routes.root}products/${t}.js`;
        return window
          .fetch(e)
          .then((t) => t.json())
          .catch((t) => {
            console.error(t);
          });
      })(this.handle).then((e) => {
        (this.product = e),
          (this.colorOption = e.options.find(function (e) {
            return e.name.toLowerCase() === t || null;
          })),
          this.colorOption && this.init();
      });
    }
    init() {
      if (
        ((this.swatchCount = this.productInfo.querySelector(`[${ms}]`)),
        (this.swatchFieldset = this.productInfo.querySelector(os)),
        (this.hideSwatchesTimer = 0),
        this.swatchCount.hasAttribute(ms))
      ) {
        if ("text" == this.swatchesStyle || "text-slider" == this.swatchesStyle) {
          if ("text" == this.swatchesStyle) return;
          this.swatchCount.addEventListener("mouseenter", () => {
            this.hideSwatchesTimer && clearTimeout(this.hideSwatchesTimer),
              this.productInfo.classList.add(cs),
              this.swatchFieldset.classList.add(ds);
          }),
            this.productInfo.addEventListener("mouseleave", () => {
              this.hideSwatchesTimer = setTimeout(() => {
                this.productInfo.classList.remove(cs), this.swatchFieldset.classList.remove(ds);
              }, 100);
            });
        }
        ("slider" != this.collectionSwatchesStyle && "grid" != this.collectionSwatchesStyle) ||
          this.swatchFieldset.classList.add(ds),
          "limited" == this.swatchesStyle && this.swatchFieldset.classList.add(ds);
      }
      this.bindSwatchButtonEvents();
    }
    bindSwatchButtonEvents() {
      var t;
      null === (t = this.querySelectorAll(ls)) ||
        void 0 === t ||
        t.forEach((t) => {
          t.addEventListener("mouseenter", this.showVariantImageEvent);
        }),
        this.productItem.addEventListener("mouseleave", this.productItemMouseLeaveEvent);
    }
    showVariantImage(t) {
      var e;
      const s = null === (e = t.target.getAttribute(ps)) || void 0 === e ? void 0 : e.replaceAll('"', "'"),
        i = this.productImage.querySelectorAll(`[${vs}]`),
        o = this.productImage.querySelector(`[${vs}="${s}"]`);
      null == i ||
        i.forEach((t) => {
          t.classList.remove(ds);
        }),
        null == o || o.classList.add(ds);
    }
    hideVariantImages() {
      var t;
      null === (t = this.productImage.querySelectorAll(`[${vs}].${ds}`)) ||
        void 0 === t ||
        t.forEach((t) => {
          t.classList.remove(ds);
        });
    }
    disconnectedCallback() {
      document.removeEventListener("theme:resize:width", this.resizeEvent);
    }
    constructor() {
      super(),
        (this.productItemMouseLeaveEvent = () => this.hideVariantImages()),
        (this.showVariantImageEvent = (t) => this.showVariantImage(t)),
        (this.resizeEvent = () => this.init());
    }
  };
  const bs = ".flickity-prev-next-button",
    ws = "[data-product-link]",
    ys = "[data-hover-slide]",
    Es = "[data-hover-slide-touch]",
    fs = "[data-hover-slider]",
    Ls = "recently-viewed",
    Ss = "video",
    As = '[data-host="vimeo"]',
    ks = '[data-host="youtube"]';
  let Cs = class extends HTMLElement {
    connectedCallback() {
      this.addArrowClickHandler(),
        this.recentlyViewed
          ? this.recentlyViewed.addEventListener("theme:recently-viewed:loaded", () => {
              this.initBasedOnDevice();
            })
          : this.initBasedOnDevice();
    }
    disconnectedCallback() {
      this.flkty && ((this.flkty.options.watchCSS = !1), this.flkty.destroy(), (this.flkty = null)),
        this.removeEventListener("mouseenter", this.mouseEnterEvent),
        this.removeEventListener("mouseleave", this.mouseLeaveEvent);
    }
    initBasedOnDevice() {
      window.theme.touch ? this.initTouch() : this.initFlickity();
    }
    addArrowClickHandler() {
      const t = this.closest(ws);
      t &&
        t.addEventListener("click", (t) => {
          t.target.matches(bs) && t.preventDefault();
        });
    }
    initTouch() {
      this.style.setProperty("--slides-count", this.querySelectorAll(Es).length),
        this.slider.addEventListener("scroll", this.handleScroll);
    }
    handleScroll() {
      const t = this.slider.scrollLeft / this.slider.clientWidth;
      this.style.setProperty("--slider-index", t);
    }
    initFlickity() {
      this.flkty ||
        !this.slider ||
        this.slider.classList.contains("flickity-enabled") ||
        this.querySelectorAll(ys).length < 2 ||
        ((this.flkty = new window.theme.Flickity(this.slider, {
          cellSelector: ys,
          contain: !0,
          wrapAround: !0,
          watchCSS: !0,
          autoPlay: !1,
          draggable: !1,
          pageDots: !1,
          prevNextButtons: !0,
        })),
        this.flkty.pausePlayer(),
        this.addEventListener("mouseenter", () => {
          this.flkty.unpausePlayer();
        }),
        this.addEventListener("mouseleave", () => {
          this.flkty.pausePlayer();
        }));
    }
    mouseEnterActions() {
      (this.hovered = !0), this.videoActions();
    }
    mouseLeaveActions() {
      (this.hovered = !1), this.videoActions();
    }
    videoActions() {
      const t = this.querySelector(ks),
        e = this.querySelector(As),
        s = t || e,
        i = this.querySelector(Ss);
      if (s) {
        let t = this.hovered ? "playVideo" : "pauseVideo",
          i = `{"event":"command","func":"${t}","args":""}`;
        e && ((t = this.hovered ? "play" : "pause"), (i = `{"method":"${t}"}`)),
          s.contentWindow.postMessage(i, "*"),
          s.addEventListener("load", (t) => {
            this.videoActions();
          });
      } else i && (this.hovered ? i.play() : i.pause());
    }
    constructor() {
      super(),
        (this.flkty = null),
        (this.slider = this.querySelector(fs)),
        (this.handleScroll = this.handleScroll.bind(this)),
        (this.recentlyViewed = this.closest(Ls)),
        (this.hovered = !1),
        (this.mouseEnterEvent = () => this.mouseEnterActions()),
        (this.mouseLeaveEvent = () => this.mouseLeaveActions()),
        this.addEventListener("mouseenter", this.mouseEnterEvent),
        this.addEventListener("mouseleave", this.mouseLeaveEvent);
    }
  };
  const qs = {
      added: "is-added",
      animated: "is-animated",
      disabled: "is-disabled",
      error: "has-error",
      loading: "is-loading",
      open: "is-open",
      overlayText: "product-item--overlay-text",
      visible: "is-visible",
      siblingLinkCurrent: "sibling__link--current",
    },
    Ts = "[data-animation]",
    Ms = "[data-api-content]",
    xs = "[data-quick-add-btn]",
    Hs = "[data-add-to-cart]",
    Is = 'button, [href], select, textarea, [tabindex]:not([tabindex="-1"])',
    Ps = "[data-message-error]",
    Ds = "[data-quick-add-modal-handle]",
    Os = "[data-product-upsell-ajax]",
    Fs = "[data-quick-add-modal-close]",
    Bs = "data-grid-item",
    $s = "[data-product-information]",
    _s = "[data-quick-add-holder]",
    Rs = "[data-quick-add-modal]",
    Ws = "[data-quick-add-modal-template]",
    Ns = "closing",
    Us = "data-product-id",
    Vs = "data-quick-add-modal-handle",
    zs = "data-sibling-swapper",
    js = "data-quick-add-holder";
  let Xs = class extends HTMLElement {
    connectedCallback() {
      this.modalButton && this.modalButton.addEventListener("click", this.modalButtonClickEvent),
        this.buttonATC &&
          this.buttonATC.addEventListener("click", (t) => {
            t.preventDefault(),
              (window.a11y.lastElement = this.buttonATC),
              document.dispatchEvent(new CustomEvent("theme:cart:add", { detail: { button: this.buttonATC } }));
          }),
        this.quickAddHolder &&
          (this.quickAddHolder.addEventListener("animationend", this.quickAddLoadingToggle), this.errorHandler());
    }
    modalButtonClickEvent(t) {
      t.preventDefault();
      const e = this.modalButton.hasAttribute(zs),
        s = this.modalButton.classList.contains(qs.siblingLinkCurrent);
      s ||
        (this.modalButton.classList.add(qs.loading),
        (this.modalButton.disabled = !0),
        e && !s && ((this.currentModal = t.target.closest(Rs)), this.currentModal.classList.add(qs.loading)),
        this.renderModal());
    }
    modalCreate(t) {
      const e = this.quickAddHolder.querySelector(Ws);
      if (!e) return;
      const s = document.createElement("div");
      (s.innerHTML = e.innerHTML),
        document.body.appendChild(s.querySelector(Rs)),
        (this.modal = document.querySelector(`${Rs}[${Us}="${this.productId}"]`)),
        (this.modal.querySelector(Os).innerHTML = new DOMParser()
          .parseFromString(t, "text/html")
          .querySelector(Ms).innerHTML),
        this.modalCreatedCallback();
    }
    modalOpen() {
      this.currentModal && this.currentModal.dispatchEvent(new CustomEvent("theme:modal:close", { bubbles: !1 })),
        "function" == typeof this.modal.show && this.modal.show(),
        this.modal.setAttribute("open", !0),
        this.modal.removeAttribute("inert"),
        this.quickAddHolder.classList.add(qs.disabled),
        this.modalButton &&
          (this.modalButton.classList.remove(qs.loading),
          (this.modalButton.disabled = !1),
          (window.a11y.lastElement = this.modalButton)),
        requestAnimationFrame(() => {
          this.modal.querySelectorAll(Ts).forEach((t) => {
            t.classList.add(qs.animated);
          });
        }),
        document.dispatchEvent(new CustomEvent("theme:quick-add:open", { bubbles: !0 })),
        document.dispatchEvent(new CustomEvent("theme:scroll:lock", { bubbles: !0 })),
        document.addEventListener("theme:product:added", this.modalCloseOnProductAdded, { once: !0 });
    }
    modalClose() {
      if (!this.isAnimating) {
        if (!this.modal.hasAttribute(Ns)) return this.modal.setAttribute(Ns, ""), void (this.isAnimating = !0);
        "function" == typeof this.modal.close ? this.modal.close() : this.modal.removeAttribute("open"),
          this.modal.removeAttribute(Ns),
          this.modal.setAttribute("inert", ""),
          this.modal.classList.remove(qs.loading),
          this.modalButton && (this.modalButton.disabled = !1),
          this.quickAddHolder &&
            this.quickAddHolder.classList.contains(qs.disabled) &&
            this.quickAddHolder.classList.remove(qs.disabled),
          this.resetAnimatedItems(),
          document.dispatchEvent(
            new CustomEvent("theme:tooltip:close", { bubbles: !0, detail: { hideTransition: !0, immediate: !0 } })
          ),
          window.theme.hasOpenModals() ||
            document.dispatchEvent(new CustomEvent("theme:scroll:unlock", { bubbles: !0 })),
          document.removeEventListener("theme:product:added", this.modalCloseOnProductAdded),
          this.a11y.removeTrapFocus(),
          this.a11y.autoFocusLastElement(),
          this.modalRemove();
      }
    }
    modalRemove() {
      window.theme
        .waitForAllAnimationsEnd(this.modal)
        .then(() => {
          var t;
          null === (t = this.modal) || void 0 === t || t.remove();
        })
        .catch(() => {
          var t;
          null === (t = this.modal) || void 0 === t || t.remove();
        });
    }
    modalEvents() {
      var t;
      null === (t = this.modal.querySelector(Fs)) ||
        void 0 === t ||
        t.addEventListener("click", (t) => {
          t.preventDefault(), this.modalClose();
        }),
        this.modal.addEventListener("click", (t) => {
          "DIALOG" === t.target.nodeName && "click" === t.type && this.modalClose();
        }),
        this.modal.addEventListener("keydown", (t) => {
          "Escape" == t.code && (t.preventDefault(), this.modalClose());
        }),
        this.modal.addEventListener("theme:modal:close", () => {
          this.modalClose();
        }),
        this.modal.addEventListener("animationend", (t) => {
          t.target === this.modal &&
            ((this.isAnimating = !1),
            this.modal.hasAttribute(Ns)
              ? this.modalClose()
              : setTimeout(() => {
                  this.a11y.trapFocus(this.modal);
                  const t = this.modal.querySelector("[autofocus]") || this.modal.querySelector(Is);
                  null == t || t.focus();
                }, 50));
        });
    }
    modalCloseOnProductAdded() {
      this.resetQuickAddButtons(), this.modal && this.modal.hasAttribute("open") && this.modalClose();
    }
    quickAddLoadingToggle(t) {
      t.target == this.quickAddHolder && this.quickAddHolder.classList.remove(qs.disabled);
    }
    errorHandler() {
      this.quickAddHolder.addEventListener("theme:cart:error", (t) => {
        const e = t.detail.holder,
          s = e.closest(`[${Bs}]`);
        if (!s) return;
        const i = e.querySelector(Ps),
          o = s.classList.contains(qs.overlayText),
          n = s.querySelector($s),
          r = e.querySelector(Hs);
        if (r) {
          r.classList.remove(qs.added, qs.loading), e.classList.add(qs.error);
          const t = () => {
            this.resetQuickAddButtons(), o && n.classList.remove(qs.hidden), e.removeEventListener("animationend", t);
          };
          e.addEventListener("animationend", t);
        }
        i && (i.innerText = t.detail.description), o && n.classList.add(qs.hidden);
      });
    }
    resetQuickAddButtons() {
      this.quickAddHolder && this.quickAddHolder.classList.remove(qs.visible, qs.error),
        this.buttonQuickAdd && (this.buttonQuickAdd.classList.remove(qs.added), (this.buttonQuickAdd.disabled = !1));
    }
    renderModal() {
      window
        .fetch(`${window.theme.routes.root}products/${this.handle}?section_id=api-product-upsell`)
        .then(this.upsellErrorsHandler)
        .then((t) => t.text())
        .then((t) => {
          this.modalCreate(t);
        });
    }
    modalCreatedCallback() {
      this.modalEvents(), this.modalOpen(), A(this.modal);
    }
    upsellErrorsHandler(t) {
      return t.ok
        ? t
        : t.json().then(function (e) {
            throw new W({ status: t.statusText, headers: t.headers, json: e });
          });
    }
    resetAnimatedItems() {
      var t;
      null === (t = this.modal) ||
        void 0 === t ||
        t.querySelectorAll(Ts).forEach((t) => {
          t.classList.remove(qs.animated);
        });
    }
    constructor() {
      var t;
      (super(), (this.quickAddHolder = this.querySelector(_s)), this.quickAddHolder) &&
        ((this.modal = null),
        (this.currentModal = null),
        (this.productId = this.quickAddHolder.getAttribute(js)),
        (this.modalButton = this.quickAddHolder.querySelector(Ds)),
        (this.handle = null === (t = this.modalButton) || void 0 === t ? void 0 : t.getAttribute(Vs)),
        (this.buttonQuickAdd = this.quickAddHolder.querySelector(xs)),
        (this.buttonATC = this.quickAddHolder.querySelector(Hs)),
        (this.button = this.modalButton || this.buttonATC),
        (this.modalClose = this.modalClose.bind(this)),
        (this.modalCloseOnProductAdded = this.modalCloseOnProductAdded.bind(this)),
        (this.a11y = window.theme.a11y),
        (this.isAnimating = !1),
        (this.modalButtonClickEvent = this.modalButtonClickEvent.bind(this)),
        (this.quickAddLoadingToggle = this.quickAddLoadingToggle.bind(this)));
    }
  };
  customElements.get("quick-add-product") || customElements.define("quick-add-product", Xs),
    customElements.get("grid-swatch") || customElements.define("grid-swatch", gs),
    customElements.get("hover-images") || customElements.define("hover-images", Cs);
  const Ks = "[data-button-arrow]",
    Qs = "[data-deferred-media-button]",
    Ys = "model-viewer, video, iframe, button, [href], input, [tabindex]",
    Gs = "[data-image-id]",
    Js = "[data-product-media-list]",
    Zs = "[data-section-id]",
    ti = "slider__arrows",
    ei = "is-dragging",
    si = "is-focused",
    ii = "media--active",
    oi = "media--hidden",
    ni = "media--hiding",
    ri = "data-active-media",
    ai = "data-button-prev",
    li = "data-button-next",
    di = "data-image-id",
    ci = "data-media-id",
    hi = "data-type",
    ui = "data-fader-desktop",
    mi = "data-fader-mobile";
  function pi(t, e, s) {
    return (
      e in t ? Object.defineProperty(t, e, { value: s, enumerable: !0, configurable: !0, writable: !0 }) : (t[e] = s), t
    );
  }
  customElements.get("product-images") ||
    customElements.define(
      "product-images",
      class extends HTMLElement {
        connectedCallback() {
          Object.keys(this.productMediaItems).length < 2 ||
            (this.productMediaObserver(), this.toggleEvents(), this.listen(), this.setHeight());
        }
        disconnectedCallback() {
          this.unlisten();
        }
        listen() {
          document.addEventListener("theme:resize:width", this.toggleEvents),
            document.addEventListener("theme:resize:width", this.setHeight),
            this.addEventListener("theme:media:select", this.selectMediaEvent);
        }
        unlisten() {
          document.removeEventListener("theme:resize:width", this.toggleEvents),
            document.removeEventListener("theme:resize:width", this.setHeight),
            this.removeEventListener("theme:media:select", this.selectMediaEvent);
        }
        toggleEvents() {
          const t = window.theme.isMobile();
          (t && this.hasAttribute(mi)) || (!t && this.hasAttribute(ui))
            ? this.bindEventListeners()
            : this.unbindEventListeners();
        }
        bindEventListeners() {
          this.initialized ||
            (this.productMediaList.addEventListener("mousedown", this.handleMouseDown),
            this.productMediaList.addEventListener("mouseleave", this.handleMouseLeave),
            this.productMediaList.addEventListener("mouseup", this.handleMouseUp),
            this.productMediaList.addEventListener("mousemove", this.handleMouseMove),
            this.productMediaList.addEventListener("touchstart", this.handleMouseDown, { passive: !0 }),
            this.productMediaList.addEventListener("touchend", this.handleMouseUp, { passive: !0 }),
            this.productMediaList.addEventListener("touchmove", this.handleMouseMove, { passive: !0 }),
            this.productMediaList.addEventListener("keyup", this.handleKeyUp),
            this.initArrows(),
            this.resetScrollPosition(),
            (this.initialized = !0));
        }
        unbindEventListeners() {
          this.initialized &&
            (this.productMediaList.removeEventListener("mousedown", this.handleMouseDown),
            this.productMediaList.removeEventListener("mouseleave", this.handleMouseLeave),
            this.productMediaList.removeEventListener("mouseup", this.handleMouseUp),
            this.productMediaList.removeEventListener("mousemove", this.handleMouseMove),
            this.productMediaList.removeEventListener("touchstart", this.handleMouseDown),
            this.productMediaList.removeEventListener("touchend", this.handleMouseUp),
            this.productMediaList.removeEventListener("touchmove", this.handleMouseMove),
            this.productMediaList.removeEventListener("keyup", this.handleKeyUp),
            this.removeArrows(),
            (this.initialized = !1));
        }
        handleMouseDown(t) {
          (this.isDown = !0),
            (this.startX = (t.pageX || t.changedTouches[0].screenX) - this.offsetLeft),
            (this.startY = (t.pageY || t.changedTouches[0].screenY) - this.offsetTop);
        }
        handleMouseLeave() {
          this.isDown && (this.isDown = !1);
        }
        handleMouseUp(t) {
          const e = (t.pageX || t.changedTouches[0].screenX) - this.offsetLeft,
            s = (t.pageY || t.changedTouches[0].screenY) - this.offsetTop,
            i = e - this.startX,
            o = s - this.startY,
            n = i > 0 ? 1 : -1,
            r = this.getCurrentMedia().hasAttribute(hi) && "image" === this.getCurrentMedia().getAttribute(hi);
          Math.abs(i) > 10 &&
            Math.abs(i) > Math.abs(o) &&
            r &&
            (n < 0 ? this.showNextImage() : this.showPreviousImage()),
            (this.isDown = !1),
            requestAnimationFrame(() => {
              this.classList.remove(ei);
            });
        }
        handleMouseMove() {
          this.isDown && this.classList.add(ei);
        }
        handleKeyUp(t) {
          "ArrowLeft" === t.code && this.showPreviousImage(), "ArrowRight" === t.code && this.showNextImage();
        }
        handleArrowsClickEvent() {
          var t;
          null === (t = this.querySelectorAll(Ks)) ||
            void 0 === t ||
            t.forEach((t) => {
              t.addEventListener("click", (t) => {
                t.preventDefault(),
                  t.target.hasAttribute(ai) && this.showPreviousImage(),
                  t.target.hasAttribute(li) && this.showNextImage();
              });
            });
        }
        resetScrollPosition() {
          0 !== this.productMediaList.scrollLeft && (this.productMediaList.scrollLeft = 0);
        }
        initArrows() {
          if (!this.buttons.length) {
            const t = document.createElement("div");
            t.classList.add(ti),
              (t.innerHTML = theme.sliderArrows.prev + theme.sliderArrows.next),
              this.productMediaList.append(t),
              (this.buttons = this.querySelectorAll(Ks)),
              (this.buttonPrev = this.querySelector(`[${ai}]`)),
              (this.buttonNext = this.querySelector(`[${li}]`));
          }
          this.handleArrowsClickEvent(), this.preloadImageOnArrowHover();
        }
        removeArrows() {
          var t;
          null === (t = this.querySelector(`.${ti}`)) || void 0 === t || t.remove();
        }
        preloadImageOnArrowHover() {
          var t, e;
          null === (t = this.buttonPrev) ||
            void 0 === t ||
            t.addEventListener("mouseover", () => {
              const t = this.getPreviousMediaId();
              this.preloadImage(t);
            }),
            null === (e = this.buttonNext) ||
              void 0 === e ||
              e.addEventListener("mouseover", () => {
                const t = this.getNextMediaId();
                this.preloadImage(t);
              });
        }
        preloadImage(t) {
          var e;
          null === (e = this.querySelector(`[${ci}="${t}"] img`)) || void 0 === e || e.setAttribute("loading", "eager");
        }
        showMediaOnVariantSelect(t) {
          const e = t.detail.id;
          this.setActiveMedia(e);
        }
        getCurrentMedia() {
          return this.querySelector(`${Gs}.${ii}`);
        }
        getNextMediaId() {
          const t = this.getCurrentMedia(),
            e = (null == t ? void 0 : t.nextElementSibling.hasAttribute(di))
              ? null == t
                ? void 0
                : t.nextElementSibling
              : this.querySelector(Gs);
          return null == e ? void 0 : e.getAttribute(ci);
        }
        getPreviousMediaId() {
          const t = this.getCurrentMedia(),
            e = this.productMediaItems.length - 1,
            s = (null == t ? void 0 : t.previousElementSibling) || this.productMediaItems[e];
          return null == s ? void 0 : s.getAttribute(ci);
        }
        showNextImage() {
          const t = this.getNextMediaId();
          this.selectMedia(t);
        }
        showPreviousImage() {
          const t = this.getPreviousMediaId();
          this.selectMedia(t);
        }
        selectMedia(t) {
          this.dispatchEvent(new CustomEvent("theme:media:select", { detail: { id: t } }));
        }
        setActiveMedia(t) {
          if (!t) return;
          this.setAttribute(ri, t);
          const e = this.querySelector(`${Gs}.${ii}`),
            s = this.querySelector(`[${ci}="${t}"]`),
            i = null == s ? void 0 : s.querySelector(Ys),
            o = s.querySelector("deferred-media");
          var n;
          (null == e || e.classList.add(ni),
          null == e || e.classList.remove(ii),
          null == s || s.classList.remove(ni, oi),
          null == s || s.classList.add(ii),
          o && !0 !== o.getAttribute("loaded")) &&
            (null === (n = s.querySelector(Qs)) ||
              void 0 === n ||
              n.dispatchEvent(new Event("click", { bubbles: !1 })));
          requestAnimationFrame(() => {
            this.setHeight(), document.body.classList.contains(si) && (null == i || i.focus());
          });
        }
        setHeight() {
          var t, e;
          const s =
            (null === (t = this.querySelector(`${Gs}.${ii}`)) || void 0 === t ? void 0 : t.offsetHeight) ||
            (null === (e = this.productMediaItems[0]) || void 0 === e ? void 0 : e.offsetHeight);
          this.style.setProperty("--height", `${s}px`);
        }
        productMediaObserver() {
          this.productMediaItems.forEach((t) => {
            t.addEventListener("transitionend", (e) => {
              e.target == t && t.classList.contains(ni) && (t.classList.remove(ni), t.classList.add(oi));
            }),
              t.addEventListener("transitioncancel", (e) => {
                e.target == t && t.classList.contains(ni) && (t.classList.remove(ni), t.classList.add(oi));
              });
          });
        }
        constructor() {
          super(),
            (this.initialized = !1),
            (this.buttons = !1),
            (this.isDown = !1),
            (this.startX = 0),
            (this.startY = 0),
            (this.scrollLeft = 0),
            (this.onButtonArrowClick = (t) => this.buttonArrowClickEvent(t)),
            (this.container = this.closest(Zs)),
            (this.handleMouseDown = this.handleMouseDown.bind(this)),
            (this.handleMouseLeave = this.handleMouseLeave.bind(this)),
            (this.handleMouseUp = this.handleMouseUp.bind(this)),
            (this.handleMouseMove = this.handleMouseMove.bind(this)),
            (this.handleKeyUp = this.handleKeyUp.bind(this)),
            (this.productMediaItems = this.querySelectorAll(Gs)),
            (this.productMediaList = this.querySelector(Js)),
            (this.setHeight = this.setHeight.bind(this)),
            (this.toggleEvents = this.toggleEvents.bind(this)),
            (this.selectMediaEvent = (t) => this.showMediaOnVariantSelect(t));
        }
      }
    );
  const vi = "[data-swap-handle]",
    gi = "native-scrollbar",
    bi = ".sibling__link--current",
    wi = "data-swap-handle";
  function yi(t) {
    return t.replace(/http(s)?:/, "");
  }
  customElements.get("product-item") ||
    customElements.define(
      "product-item",
      class extends HTMLElement {
        connectedCallback() {
          var t;
          this.scrollIntoView(),
            null === (t = this.swapHandles) ||
              void 0 === t ||
              t.forEach((t) => {
                t.addEventListener("click", this.handleClick), t.addEventListener("keyup", this.handleKeyup);
              }),
            this.initProductSwapUtility();
        }
        disconnectedCallback() {
          var t, e;
          null === (t = this.abortController) || void 0 === t || t.abort(),
            null === (e = this.swapHandles) ||
              void 0 === e ||
              e.forEach((t) => {
                t.removeEventListener("click", this.handleClick), t.removeEventListener("keyup", this.handleKeyup);
              });
        }
        initProductSwapUtility() {
          this.postProcessHtmlCallbacks.push(() => {
            document.addEventListener("theme:html:change", this.onHtmlChange);
          });
        }
        handleChange(t) {
          if (!this.contains(t.target)) return;
          const e = t.target.closest(vi),
            s = e.dataset.swapUrl,
            i = `${window.Shopify.routes.root}products/${e.dataset.swapHandle}`;
          this.pendingSwapHandle = e.dataset.swapHandle;
          this.dataset.url !== s &&
            this.renderProductItem({
              requestUrl: `${i}?section_id=api-product-grid-item`,
              callback: this.handleSwapProduct(),
            });
        }
        handleSwapProduct() {
          return (t) => {
            const e = t.querySelector("product-item"),
              s = e.id ? `#${e.id}` : "";
            let i = e.outerHTML;
            (i = i.includes("||itemAnimationDelay||") ? i.replaceAll("||itemAnimationDelay||", 0) : i),
              (i = i.includes("||itemAnimationAnchor||") ? i.replaceAll("||itemAnimationAnchor||", s) : i);
            const o = document.createElement("div");
            o.innerHTML = i;
            const n = o.querySelector("product-item");
            window.theme.htmlUpdate.viewTransition(this, n, this.postProcessHtmlCallbacks);
          };
        }
        renderProductItem({ requestUrl: t, callback: e }) {
          var s;
          null === (s = this.abortController) || void 0 === s || s.abort(),
            (this.abortController = new AbortController()),
            fetch(t, { signal: this.abortController.signal })
              .then((t) => t.text())
              .then((t) => {
                const s = new DOMParser().parseFromString(t, "text/html");
                e(s);
              })
              .catch((t) => {
                "AbortError" === t.name ? console.log("Fetch aborted by user") : console.error(t),
                  document.removeEventListener("theme:html:change", this.onHtmlChange);
              });
        }
        handleHtmlChange(t) {
          var e;
          if (!(null == t || null === (e = t.detail) || void 0 === e ? void 0 : e.element)) return;
          if (!this.pendingSwapHandle) return;
          const s = t.detail.element,
            i = s.querySelector(`[${wi}="${this.pendingSwapHandle}"]`);
          i.focus(),
            this.scrollIntoView({ product: s, swatch: i }),
            (this.pendingSwapHandle = null),
            document.removeEventListener("theme:html:change", this.onHtmlChange);
        }
        scrollIntoView(t = !1) {
          if (!this.activeSibling) return;
          const e = t ? t.swatch : this.activeSibling,
            s = (t ? t.product : this).querySelector(gi);
          if (!s || "function" != typeof s.move) return;
          const i = getComputedStyle(e),
            o = e.offsetLeft + parseFloat(i.marginLeft) + parseFloat(i.marginRight);
          requestAnimationFrame(() => s.move(o - e.clientWidth, "instant"));
        }
        constructor() {
          super(),
            pi(this, "abortController", void 0),
            pi(this, "pendingSwapHandle", null),
            pi(this, "postProcessHtmlCallbacks", []),
            pi(this, "handleClick", (t) => this.handleChange(t)),
            pi(this, "handleKeyup", (t) => {
              (t.code !== theme.keyboardKeys.ENTER && t.code !== theme.keyboardKeys.NUMPADENTER) ||
                this.handleChange(t);
            }),
            pi(this, "onHtmlChange", (t) => this.handleHtmlChange(t)),
            (this.swapHandles = this.querySelectorAll(vi)),
            (this.activeSibling = [...this.swapHandles].find((t) => t.querySelector(bi)));
        }
      }
    );
  const Ei = {
      productCutline: "[data-product-cutline]",
      productLink: "[data-product-link]",
      productGridItem: "[data-grid-item]",
      productInfo: "[data-product-information]",
      productImage: "[data-product-image-default]",
      productImageSibling: "[data-product-image-sibling]",
      productPrice: "[data-product-price]",
      siblingsInnerHolder: "[data-sibling-inner]",
      siblingCount: "[data-sibling-count]",
      siblingFieldset: "[data-sibling-fieldset]",
      siblingLink: "[data-sibling-link]",
      siblingLinkCurrent: ".sibling__link--current",
    },
    fi = "is-visible",
    Li = "is-fade",
    Si = "no-events",
    Ai = "is-active",
    ki = "is-focused",
    Ci = "data-sibling-cutline",
    qi = "data-sibling-image",
    Ti = "data-sibling-price",
    Mi = "data-sibling-compare-at-price",
    xi = "data-product-link",
    Hi = "data-sibling-link",
    Ii = "data-mobile-columns-small";
  customElements.get("product-item-siblings") ||
    customElements.define(
      "product-item-siblings",
      class extends HTMLElement {
        connectedCallback() {
          (this.product = this.closest(Ei.productGridItem)),
            (this.siblingCount = this.querySelector(Ei.siblingCount)),
            (this.siblingFieldset = this.querySelector(Ei.siblingFieldset)),
            (this.siblingLinks = this.querySelectorAll(Ei.siblingLink)),
            (this.productInfo = this.closest(Ei.productInfo)),
            (this.productLink = this.closest(Ei.link)),
            (this.hideSwatchesTimer = 0),
            (this.swatchesStyle = theme.settings.collectionSwatchStyle),
            this.siblingFieldset &&
              this.productInfo &&
              (("grid" != this.swatchesStyle && "slider" != this.swatchesStyle && "limited" != this.swatchesStyle) ||
                this.siblingFieldset.classList.add(fi),
              this.siblingCount &&
                (this.siblingCount.addEventListener("mouseenter", () => this.showSiblings()),
                this.productInfo.addEventListener("mouseleave", () => this.hideSiblings()))),
            this.siblingLinks.length &&
              new (class {
                init() {
                  this.cacheDefaultValues(),
                    this.siblingsInnerHolder.addEventListener("mouseleave", () => this.resetProductValues()),
                    this.siblingsInnerHolder.addEventListener("focusout", () => {
                      document.body.classList.contains(ki) && this.resetProductValues();
                    }),
                    this.swatches.forEach((t) => {
                      t.addEventListener("mouseenter", (t) => this.showSibling(t)),
                        t.addEventListener("focusin", (t) => {
                          document.body.classList.contains(ki) && this.showSibling(t);
                        });
                    }),
                    this.productLinks.length &&
                      this.swatches.forEach((t) => {
                        t.addEventListener("click", () => {
                          this.productLinks[0].click();
                        });
                      });
                }
                cacheDefaultValues() {
                  var t;
                  (this.activeSibling =
                    null === (t = this.siblingsInnerHolder.querySelector(Ei.siblingLinkCurrent)) || void 0 === t
                      ? void 0
                      : t.closest(Ei.siblingLink)),
                    this.activeSibling &&
                      this.productImageSibling.setAttribute(qi, this.activeSibling.dataset.siblingImage),
                    (this.productLinkValue = this.productLinks[0].hasAttribute(xi)
                      ? this.productLinks[0].getAttribute(xi)
                      : ""),
                    (this.productPriceValue = this.productPrice.innerHTML),
                    this.productCutline && (this.productCutlineValue = this.productCutline.innerHTML);
                }
                resetProductValues() {
                  this.product.classList.remove(Ai),
                    this.productLinkValue &&
                      this.productLinks.forEach((t) => {
                        t.href = this.productLinkValue;
                      }),
                    this.productPrice && (this.productPrice.innerHTML = this.productPriceValue),
                    this.productCutline &&
                      this.productCutline &&
                      ((this.productCutline.innerHTML = this.productCutlineValue),
                      (this.productCutline.title = this.productCutlineValue)),
                    this.hideSiblingImage();
                }
                showSibling(t) {
                  const e = t.target,
                    s = e.hasAttribute(Hi) ? e.getAttribute(Hi) : "",
                    i = e.hasAttribute(Ti) ? e.getAttribute(Ti) : "",
                    o = e.hasAttribute(Mi) ? e.getAttribute(Mi) : "",
                    n = e.hasAttribute(Ci) ? e.getAttribute(Ci) : "",
                    r = e.hasAttribute(qi) ? e.getAttribute(qi) : "";
                  s &&
                    this.productLinks.forEach((t) => {
                      t.href = s;
                    }),
                    (this.productPrice.innerHTML = o
                      ? `<span class="price sale"><span class="new-price">${i}</span> <span class="old-price">${o}</span></span>`
                      : `<span class="price">${i}</span>`),
                    this.productCutline &&
                      (n
                        ? ((this.productCutline.innerHTML = n), (this.productCutline.title = n))
                        : ((this.productCutline.innerHTML = ""), (this.productCutline.title = ""))),
                    r && this.showSiblingImage(r);
                }
                showSiblingImage(t) {
                  if (!this.productImageSibling) return;
                  const e = window.devicePixelRatio || 1,
                    s = this.productImage.offsetWidth * e,
                    i = 180 * Math.ceil(s / 180),
                    o = (function (t, e) {
                      if (null === e) return t;
                      if ("master" === e) return yi(t);
                      const s = t.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);
                      if (s) {
                        const i = t.split(s[0]),
                          o = s[0];
                        return yi(`${i[0]}_${e}${o}`);
                      }
                      return null;
                    })(t, `${i}x`),
                    n = this.productImageSibling.querySelector(`[src="${o}"]`),
                    r = () => {
                      this.productImageSibling.classList.add(fi),
                        this.productImageSibling.querySelector(`[src="${o}"]`).classList.add(Li);
                    },
                    a = () => {
                      const e = this.productImageSibling.getAttribute(qi),
                        s = t !== e,
                        i = t === e && this.productImageSibling.classList.contains(fi);
                      Boolean(i || s) &&
                        (this.productImageSibling.querySelectorAll("img").forEach((t) => {
                          t.classList.remove(Li);
                        }),
                        requestAnimationFrame(r));
                    };
                  if (n) a();
                  else {
                    const t = document.createElement("img");
                    (t.src = o),
                      this.productCutline && (t.alt = this.productCutline.innerText),
                      t.addEventListener("load", () => {
                        this.productImageSibling.append(t), a();
                      });
                  }
                }
                hideSiblingImage() {
                  this.productImageSibling &&
                    (this.productImageSibling.classList.remove(fi),
                    this.productImageSibling.querySelectorAll("img").forEach((t) => {
                      t.classList.remove(Li);
                    }));
                }
                constructor(t, e) {
                  (this.swatches = t),
                    (this.product = e),
                    (this.productLinks = this.product.querySelectorAll(Ei.productLink)),
                    (this.productCutline = this.product.querySelector(Ei.productCutline)),
                    (this.productPrice = this.product.querySelector(Ei.productPrice)),
                    (this.productImage = this.product.querySelector(Ei.productImage)),
                    (this.productImageSibling = this.product.querySelector(Ei.productImageSibling)),
                    (this.siblingsInnerHolder = this.product.querySelector(Ei.siblingsInnerHolder)),
                    this.init();
                }
              })(this.siblingLinks, this.product),
            document.addEventListener("theme:resize:width", this.resizeEvent);
        }
        disconnectedCallback() {
          document.removeEventListener("theme:resize:width", this.resizeEvent);
        }
        handleResize() {
          this.siblingFieldset &&
            this.productInfo &&
            (("grid" != this.swatchesStyle && "slider" != this.swatchesStyle && "limited" != this.swatchesStyle) ||
              (this.siblingFieldset.classList.add(fi), this.limitVisibleSwatches()));
        }
        showSiblings() {
          this.hideSwatchesTimer && clearTimeout(this.hideSwatchesTimer),
            this.productLink && this.productLink.classList.add(Si),
            "text" != this.swatchesStyle && this.siblingFieldset.classList.add(fi);
        }
        hideSiblings() {
          this.hideSwatchesTimer = setTimeout(() => {
            this.productLink && this.productLink.classList.remove(Si), this.siblingFieldset.classList.remove(fi);
          }, 100);
        }
        limitVisibleSwatches() {
          var t;
          const e = window.theme.isMobile(),
            s = this.querySelector(`[${Ii}]`),
            i = "true" === (null == s ? void 0 : s.getAttribute(Ii));
          if (!(null === (t = this.siblingLinks) || void 0 === t ? void 0 : t.length) || (e && !i)) return;
          if (!e && "limited" !== this.swatchesStyle) {
            this.siblingLinks.forEach((t) => {
              t.style.display = "";
            });
            const t = this.querySelector(".swatch-limited");
            return void (t && t.remove());
          }
          const o = e ? 3 : 5,
            n = this.siblingLinks.length,
            r = Math.min(o, n),
            a = n - r;
          this.siblingLinks.forEach((t, e) => {
            t.style.display = e < r ? "" : "none";
          });
          const l = this.querySelector(".swatch-limited");
          if (a > 0)
            if (l) l.textContent = `+${a}`;
            else {
              const t = document.createElement("div");
              (t.className = "swatch-limited"), (t.textContent = `+${a}`), null == s || s.appendChild(t);
            }
          else l && l.remove();
        }
        constructor() {
          super(), (this.resizeEvent = () => this.handleResize());
        }
      }
    ),
    (Shopify.Products = (function () {
      const t = {
        howManyToShow: 4,
        howManyToStoreInMemory: 10,
        wrapperId: "recently-viewed-products",
        section: null,
        target: "api-product-grid-item",
        onComplete: null,
      };
      let e = [],
        s = null,
        i = null;
      const o = new Date(),
        n = new Date();
      n.setTime(o.getTime() + 7776e6);
      const r = {
          configuration: {
            expires: n.toGMTString(),
            path: "/",
            domain: window.location.hostname,
            sameSite: "none",
            secure: !0,
          },
          name: "shopify_recently_viewed",
          write: function (t) {
            const e = encodeURIComponent(t.join(" "));
            document.cookie = `${this.name}=${e}; expires=${this.configuration.expires}; path=${this.configuration.path}; domain=${this.configuration.domain}; sameSite=${this.configuration.sameSite}; secure=${this.configuration.secure}`;
          },
          read: function () {
            let t = [],
              e = null;
            return (
              -1 !== document.cookie.indexOf("; ") &&
                document.cookie.split("; ").find((t) => t.startsWith(this.name)) &&
                (e = document.cookie
                  .split("; ")
                  .find((t) => t.startsWith(this.name))
                  .split("=")[1]),
              null !== e && (t = decodeURIComponent(e).split(" ")),
              t
            );
          },
          destroy: function () {
            document.cookie = `${this.name}=null; expires=${this.configuration.expires}; path=${this.configuration.path}; domain=${this.configuration.domain}`;
          },
          remove: function (t) {
            const e = this.read(),
              s = e.indexOf(t);
            -1 !== s && (e.splice(s, 1), this.write(e));
          },
        },
        a = (e, s, o, n, l, d) => {
          s.length && e < d
            ? fetch(`${window.theme.routes.root}products/${s[0]}?section_id=${l}`)
                .then((t) => t.text())
                .then((t) => {
                  const i = 100 * e,
                    r = o.id ? `#${o.id}` : "",
                    c = document.createElement("div");
                  let h = t;
                  (h = h.includes("||itemAnimationDelay||") ? h.replaceAll("||itemAnimationDelay||", i) : h),
                    (h = h.includes("||itemAnimationAnchor||") ? h.replaceAll("||itemAnimationAnchor||", r) : h),
                    (c.innerHTML = h),
                    (o.innerHTML += c.querySelector("[data-api-content]").innerHTML),
                    s.shift(),
                    e++,
                    a(e, s, o, n, l, d);
                })
                .catch(() => {
                  r.remove(s[0]), s.shift(), a(e, s, o, n, l, d);
                })
            : ((e, s) => {
                e.classList.remove("hidden");
                const o = r.read().length;
                if (Shopify.recentlyViewed && i && o && o < i && e.children.length) {
                  let t = [],
                    s = [],
                    i = 0;
                  for (const e in Shopify.recentlyViewed) {
                    i += 1;
                    const o = Shopify.recentlyViewed[e].split(" "),
                      n = parseInt(e.split("_")[1]);
                    (t = [...t, ...o]),
                      (r.read().length === n || (i === Object.keys(Shopify.recentlyViewed).length && !s.length)) &&
                        (s = [...s, ...o]);
                  }
                  for (let i = 0; i < e.children.length; i++) {
                    const o = e.children[i];
                    t.length && o.classList.remove(...t), s.length && o.classList.add(...s);
                  }
                }
                if (t.onComplete)
                  try {
                    t.onComplete(e, s);
                  } catch (t) {
                    console.log(t);
                  }
              })(o, n);
        };
      return {
        showRecentlyViewed: function (o) {
          if (Shopify.visualPreviewMode) return;
          const n = o || {};
          Object.assign(t, n),
            (e = r.read()),
            (s = document.querySelector(`#${t.wrapperId}`)),
            (i = t.howManyToShow),
            (t.howManyToShow = Math.min(e.length, t.howManyToShow)),
            t.howManyToShow && s && a(0, e, s, t.section, t.target, i);
        },
        getConfig: function () {
          return t;
        },
        clearList: function () {
          r.destroy();
        },
        recordRecentlyViewed: function (e) {
          const s = e || {};
          Object.assign(t, s);
          let i = r.read();
          if (-1 !== window.location.pathname.indexOf("/products/")) {
            let e = decodeURIComponent(window.location.pathname)
              .match(
                /\/products\/([a-z0-9\-]|[\u3000-\u303F]|[\u3040-\u309F]|[\u30A0-\u30FF]|[\uFF00-\uFFEF]|[\u4E00-\u9FAF]|[\u2605-\u2606]|[\u2190-\u2195]|[\u203B]|[\w\u0430-\u044f]|[\u0400-\u04FF]|[\u0900-\u097F]|[\u0590-\u05FF\u200f\u200e]|[\u0621-\u064A\u0660-\u0669 ])+/
              )[0]
              .split("/products/")[1];
            t.handle && (e = t.handle);
            const s = i.indexOf(e);
            -1 === s ? (i.unshift(e), (i = i.splice(0, t.howManyToStoreInMemory))) : (i.splice(s, 1), i.unshift(e)),
              r.write(i);
          }
        },
        hasProducts: r.read().length > 0,
      };
    })());
  const Pi = "[data-aos]",
    Di = ".collection-item__image",
    Oi = "[data-column-image]",
    Fi = ".flickity-button.next",
    Bi = ".flickity-button.previous",
    $i = "a:not(.btn)",
    _i = ".product-item__image",
    Ri = "[data-section-id]",
    Wi = "[data-slide]",
    Ni = "[data-slider-thumb]",
    Ui = "data-arrow-position-middle",
    Vi = "data-slide-index",
    zi = "data-options",
    ji = "data-slide-text-color",
    Xi = "aos-animate",
    Ki = "desktop",
    Qi = "is-focused",
    Yi = "hidden",
    Gi = "is-initialized",
    Ji = "is-loading",
    Zi = "is-selected",
    to = "mobile",
    eo = "single-slide";
  customElements.get("slider-component") ||
    customElements.define(
      "slider-component",
      class extends HTMLElement {
        connectedCallback() {
          this.initSlider();
        }
        initSlider() {
          var t;
          if (this.slides.length <= 1) return;
          this.hasAttribute(zi) && (this.customOptions = JSON.parse(decodeURIComponent(this.getAttribute(zi)))),
            this.classList.add(Ji);
          let e = Wi;
          const s = !window.theme.isMobile(),
            i = `${Wi}:not(.${to})`,
            o = `${Wi}:not(.${Ki})`;
          var n;
          (this.querySelectorAll(i).length || this.querySelectorAll(o).length) &&
            ((e = s ? i : o), null === (n = this.flkty) || void 0 === n || n.destroy());
          if (this.querySelectorAll(e).length <= 1) return this.classList.add(eo), void this.classList.remove(Ji);
          (this.sliderOptions = {
            cellSelector: e,
            contain: !0,
            wrapAround: !0,
            adaptiveHeight: !0,
            ...this.customOptions,
            on: {
              ready: () => {
                requestAnimationFrame(() => {
                  this.classList.add(Gi),
                    this.classList.remove(Ji),
                    this.parentNode.dispatchEvent(
                      new CustomEvent("theme:slider:loaded", { bubbles: !0, detail: { slider: this } })
                    );
                }),
                  this.slideActions(),
                  this.sliderOptions.prevNextButtons && this.positionArrows();
              },
              change: (t) => {
                const e = this.slides[t];
                if (!e || this.sliderOptions.groupCells) return;
                const s = e.querySelectorAll(Pi);
                s.length &&
                  s.forEach((t) => {
                    t.classList.remove(Xi),
                      requestAnimationFrame(() => {
                        setTimeout(() => {
                          t.classList.add(Xi);
                        }, 0);
                      });
                  });
              },
              resize: () => {
                this.sliderOptions.prevNextButtons && this.positionArrows();
              },
            },
          }),
            this.initFlickity(),
            this.flkty.on("change", () => this.slideActions(!0)),
            null === (t = this.thumbs) ||
              void 0 === t ||
              t.forEach((t) => {
                t.addEventListener("click", (e) => {
                  e.preventDefault();
                  const s = [...t.parentElement.children].indexOf(t);
                  this.flkty.select(s);
                });
              }),
            (this.flkty && this.flkty.isActive) || this.classList.remove(Ji);
        }
        initFlickity() {
          this.sliderOptions.fade
            ? (this.flkty = new window.theme.FlickityFade(this, this.sliderOptions))
            : (this.flkty = new window.theme.Flickity(this, this.sliderOptions));
        }
        bindEvents() {
          this.addEventListener("theme:slider:init", () => {
            this.initSlider();
          }),
            this.addEventListener("theme:slider:select", (t) => {
              this.flkty.selectCell(t.detail.index), this.flkty.stopPlayer();
            }),
            this.addEventListener("theme:slider:deselect", () => {
              this.flkty &&
                this.sliderOptions.hasOwnProperty("autoPlay") &&
                this.sliderOptions.autoPlay &&
                this.flkty.playPlayer();
            }),
            this.addEventListener("theme:slider:reposition", () => {
              var t;
              null === (t = this.flkty) || void 0 === t || t.reposition();
            }),
            this.addEventListener("theme:slider:destroy", () => {
              var t;
              null === (t = this.flkty) || void 0 === t || t.destroy();
            }),
            this.addEventListener("theme:slider:remove-slide", (t) => {
              var e, s;
              t.detail.slide &&
                (null === (e = this.flkty) || void 0 === e || e.remove(t.detail.slide),
                0 === (null === (s = this.flkty) || void 0 === s ? void 0 : s.cells.length) &&
                  this.section.classList.add(Yi));
            });
        }
        slideActions(t = !1) {
          const e = this.querySelector(`.${Zi}`);
          if (!e) return;
          const s = e.hasAttribute(ji) ? e.getAttribute(ji) : "",
            i = e.querySelector($i),
            o = this.querySelectorAll(`${Wi} a, ${Wi} button`);
          if (
            (document.body.classList.contains(Qi) && i && this.sliderOptions.groupCells && t && i.focus(),
            o.length &&
              o.forEach((t) => {
                const e = t.closest(Wi);
                if (e) {
                  const s = e.classList.contains(Zi) ? 0 : -1;
                  t.setAttribute("tabindex", s);
                }
              }),
            this.style.setProperty("--text", s),
            this.thumbs.length && this.thumbs.length === this.slides.length && e.hasAttribute(Vi))
          ) {
            const t = parseInt(e.getAttribute(Vi)),
              s = this.querySelector(`${Ni}.${Zi}`);
            s && s.classList.remove(Zi), this.thumbs[t].classList.add(Zi);
          }
        }
        positionArrows() {
          if (!this.hasAttribute(Ui) || !this.sliderOptions.prevNextButtons) return;
          const t = this.querySelector(Di) || this.querySelector(_i) || this.querySelector(Oi);
          t &&
            ((this.querySelector(Bi).style.top = t.clientHeight / 2 + "px"),
            (this.querySelector(Fi).style.top = t.clientHeight / 2 + "px"));
        }
        disconnectedCallback() {
          this.flkty && ((this.flkty.options.watchCSS = !1), this.flkty.destroy());
        }
        constructor() {
          super(),
            (this.flkty = null),
            (this.slides = this.querySelectorAll(Wi)),
            (this.thumbs = this.querySelectorAll(Ni)),
            (this.section = this.closest(Ri)),
            this.bindEvents();
        }
      }
    );
  const so = "[data-related-section]",
    io = "[data-aos]",
    oo = "[data-tab]",
    no = ".tab-link__recent",
    ro = ".tab-content",
    ao = "current",
    lo = "hidden",
    co = "aos-animate",
    ho = "aos-no-transition",
    uo = "is-focused",
    mo = "data-tab",
    po = "data-tab-index";
  customElements.get("tabs-component") ||
    customElements.define(
      "tabs-component",
      class extends HTMLElement {
        connectedCallback() {
          const t = this.querySelectorAll(oo);
          this.addEventListener("theme:tab:check", () => this.checkRecentTab()),
            this.addEventListener("theme:tab:hide", () => this.hideRelatedTab()),
            null == t ||
              t.forEach((t) => {
                const e = parseInt(t.getAttribute(mo)),
                  s = this.querySelector(`${ro}-${e}`);
                t.addEventListener("click", () => {
                  this.tabChange(t, s);
                }),
                  t.addEventListener("keyup", (e) => {
                    ("Space" !== e.code && "Enter" !== e.code) ||
                      !document.body.classList.contains(uo) ||
                      this.tabChange(t, s);
                  });
              });
        }
        tabChange(t, e) {
          if (t.classList.contains(ao)) return;
          const s = this.querySelector(`${oo}.${ao}`),
            i = this.querySelector(`${ro}.${ao}`);
          null == s || s.classList.remove(ao),
            null == i || i.classList.remove(ao),
            t.classList.add(ao),
            e.classList.add(ao),
            t.classList.contains(lo) && e.classList.add(lo),
            this.a11y.a11y.removeTrapFocus(),
            this.dispatchEvent(new CustomEvent("theme:tab:change", { bubbles: !0 })),
            t.dispatchEvent(new CustomEvent("theme:form:sticky", { bubbles: !0, detail: { element: "tab" } })),
            this.animateItems(e);
        }
        animateItems(t, e = !0) {
          const s = t.querySelectorAll(io);
          s.length &&
            s.forEach((t) => {
              t.classList.remove(co),
                e &&
                  (t.classList.add(ho),
                  requestAnimationFrame(() => {
                    t.classList.remove(ho), t.classList.add(co);
                  }));
            });
        }
        checkRecentTab() {
          const t = this.querySelector(no);
          if (t) {
            t.classList.remove(lo);
            const e = parseInt(t.getAttribute(mo)),
              s = this.querySelector(`${ro}[${po}="${e}"]`);
            s && (s.classList.remove(lo), this.animateItems(s, !1));
          }
        }
        hideRelatedTab() {
          const t = this.querySelector(so);
          if (!t) return;
          const e = t.closest(`${ro}.${ao}`);
          if (!e) return;
          const s = parseInt(e.getAttribute(po)),
            i = this.querySelectorAll(oo);
          if (i.length > s) {
            const t = i[s].nextSibling;
            t && (i[s].classList.add(lo), t.dispatchEvent(new Event("click")));
          }
        }
        constructor() {
          super(), (this.a11y = window.a11y);
        }
      }
    );
  const vo = "[data-actions]",
    go = "[data-content]",
    bo = "[data-button]",
    wo = "data-height",
    yo = "is-open",
    Eo = "is-enabled";
  let fo = class extends HTMLElement {
    connectedCallback() {
      this.setHeight(this.initialHeight),
        this.trigger.addEventListener("click", () => {
          this.setHeight(this.content.offsetHeight), this.classList.add(yo);
        }),
        this.setHeight(this.initialHeight),
        this.toggleActions(),
        document.addEventListener("theme:resize", this.toggleActions),
        document.addEventListener("theme:collapsible:toggle", this.toggleActions);
    }
    disconnectedCallback() {
      document.removeEventListener("theme:resize", this.toggleActions),
        document.removeEventListener("theme:collapsible:toggle", this.toggleActions);
    }
    setHeight(t) {
      this.style.setProperty("--height", `${t}px`);
    }
    toggleActions() {
      this.classList.toggle(Eo, this.content.offsetHeight + this.actions.offsetHeight > this.initialHeight);
    }
    constructor() {
      super(),
        (this.initialHeight = this.getAttribute(wo)),
        (this.content = this.querySelector(go)),
        (this.trigger = this.querySelector(bo)),
        (this.actions = this.querySelector(vo)),
        (this.toggleActions = this.toggleActions.bind(this));
    }
  };
  customElements.get("toggle-ellipsis") || customElements.define("toggle-ellipsis", fo);
  const Lo = "[data-section-id]",
    So = "data-tooltip",
    Ao = "data-tooltip-stop-mouseenter",
    ko = "tooltip-default",
    Co = "is-visible",
    qo = "is-hiding";
  customElements.get("tooltip-component") ||
    customElements.define(
      "tooltip-component",
      class extends HTMLElement {
        connectedCallback() {
          if (!document.querySelector(`.${ko}`)) {
            const t = `<div class="${ko}__arrow"></div><div class="${ko}__inner"><div class="${ko}__text"></div></div>`,
              e = document.createElement("div");
            (e.className = ko), (e.innerHTML = t), document.body.appendChild(e);
          }
          this.addEventListener("mouseenter", this.addPinMouseEvent),
            this.addEventListener("mouseleave", this.removePinMouseEvent),
            this.addEventListener("theme:tooltip:init", this.addPinEvent),
            document.addEventListener("theme:tooltip:close", this.removePinEvent);
        }
        addPin(t = !1) {
          const e = document.querySelector(`.${ko}`),
            s = this.closest(Lo),
            i = Array.from(s.classList).find((t) => t.startsWith("color-scheme-"));
          if ((i && (null == e || e.classList.add(i)), this.label && e && ((t && !this.hasAttribute(Ao)) || !t))) {
            const t = e.querySelector(`.${ko}__arrow`),
              s = e.querySelector(`.${ko}__inner`);
            e.querySelector(`.${ko}__text`).innerHTML = this.label;
            const i = s.offsetWidth,
              o = this.getBoundingClientRect(),
              n = o.top,
              r = o.width,
              a = n + o.height + window.scrollY;
            let l = o.left - i / 2 + r / 2;
            const d = 24,
              c = l + i - window.theme.getWindowWidth() + d;
            c > 0 && (l -= c),
              l < 0 && (l = 0),
              (t.style.left = `${o.left + r / 2}px`),
              e.style.setProperty("--tooltip-top", `${a}px`),
              (s.style.transform = `translateX(${l}px)`),
              e.classList.remove(qo),
              e.classList.add(Co),
              document.addEventListener("theme:scroll", this.removePinEvent);
          }
        }
        removePin(t, e = !1, s = !1) {
          const i = document.querySelector(`.${ko}`),
            o = i.classList.contains(Co);
          i &&
            ((e && !this.hasAttribute(Ao)) || !e) &&
            (o &&
              (s || t.detail.hideTransition) &&
              (i.classList.add(qo),
              this.hideTransitionTimeout && clearTimeout(this.hideTransitionTimeout),
              (this.hideTransitionTimeout = setTimeout(() => {
                i.classList.remove(qo);
              }, this.transitionSpeed))),
            i.classList.remove(Co),
            document.removeEventListener("theme:scroll", this.removePinEvent));
        }
        disconnectedCallback() {
          this.removeEventListener("mouseenter", this.addPinMouseEvent),
            this.removeEventListener("mouseleave", this.removePinMouseEvent),
            this.removeEventListener("theme:tooltip:init", this.addPinEvent),
            document.removeEventListener("theme:tooltip:close", this.removePinEvent),
            document.removeEventListener("theme:scroll", this.removePinEvent);
        }
        constructor() {
          super(),
            (this.label = this.hasAttribute(So) ? this.getAttribute(So) : ""),
            (this.transitionSpeed = 200),
            (this.hideTransitionTimeout = 0),
            (this.addPinEvent = () => this.addPin()),
            (this.addPinMouseEvent = () => this.addPin(!0)),
            (this.removePinEvent = (t) => window.theme.throttle(this.removePin(t), 50)),
            (this.removePinMouseEvent = (t) => this.removePin(t, !0, !0));
        }
      }
    );
  let To = class extends HTMLElement {
    connectedCallback() {
      this.addEventListener("change", (t) => {
        const e = this.getInputForEventTarget(t.target);
        publish(theme.PUB_SUB_EVENTS.optionValueSelectionChange, {
          data: { event: t, target: e, selectedOptionValues: this.selectedOptionValues },
        });
      });
    }
    getInputForEventTarget(t) {
      return "SELECT" === t.tagName ? t.selectedOptions[0] : t;
    }
    get selectedOptionValues() {
      return [
        ...Array.from(this.querySelectorAll("select option[selected]")),
        ...Array.from(this.querySelectorAll("fieldset input:checked")),
        ...Array.from(this.querySelectorAll("[data-popout-input]")),
      ]
        .map(({ dataset: t }) => t.optionValueId)
        .filter((t) => Boolean(t));
    }
    constructor() {
      super();
    }
  };
  customElements.define("variant-selects", To);
  const Mo = {};
  function xo(t = {}) {
    if ((t.type || (t.type = "json"), t.url))
      return Mo[t.url]
        ? Mo[t.url]
        : (function (t, e) {
            const s = new Promise((s, i) => {
              "text" === e
                ? fetch(t)
                    .then((t) => t.text())
                    .then((t) => {
                      s(t);
                    })
                    .catch((t) => {
                      i(t);
                    })
                : (function (t, e, s) {
                    let i = document.getElementsByTagName("head")[0],
                      o = !1,
                      n = document.createElement("script");
                    (n.src = t),
                      (n.onload = n.onreadystatechange =
                        function () {
                          o || (this.readyState && "loaded" != this.readyState && "complete" != this.readyState)
                            ? s()
                            : ((o = !0), e());
                        }),
                      i.appendChild(n);
                  })(
                    t,
                    function () {
                      s();
                    },
                    function () {
                      i();
                    }
                  );
            });
            return (Mo[t] = s), s;
          })(t.url, t.type);
    if (t.json)
      return Mo[t.json]
        ? Promise.resolve(Mo[t.json])
        : window
            .fetch(t.json)
            .then((t) => t.json())
            .then((e) => ((Mo[t.json] = e), e));
    if (t.name) {
      const e = "".concat(t.name, t.version);
      return Mo[e]
        ? Mo[e]
        : (function (t) {
            const e = "".concat(t.name, t.version),
              s = new Promise((e, s) => {
                try {
                  window.Shopify.loadFeatures([
                    {
                      name: t.name,
                      version: t.version,
                      onLoad: (t) => {
                        !(function (t, e, s) {
                          s ? e(s) : t();
                        })(e, s, t);
                      },
                    },
                  ]);
                } catch (t) {
                  s(t);
                }
              });
            return (Mo[e] = s), s;
          })(t);
    }
    return Promise.reject();
  }
  document.addEventListener("DOMContentLoaded", function () {
    const t = document.querySelector("[data-scroll-top-button]");
    t &&
      (t.addEventListener("click", () => {
        window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
      }),
      document.addEventListener("theme:scroll", () => {
        t.classList.toggle("is-visible", window.scrollY > window.innerHeight);
      })),
      window.self !== window.top && document.querySelector("html").classList.add("iframe"),
      "scrollBehavior" in document.documentElement.style || xo({ url: window.theme.assets.smoothscroll });
  }),
    window.navigator.cookieEnabled &&
      (document.documentElement.className = document.documentElement.className.replace(
        "supports-no-cookies",
        "supports-cookies"
      ));
})(themeVendor.ScrollLock);
